<template>
  <div style="min-height: calc(100% - 50px); width: 100%" id="land-box">
    <div
      id="need-land"
      @mousedown="start"
      @mousemove="move"
      @mouseup="end"
      style="height: 100%"
    >
      <tz-map
        ref="tzMap"
        :position="position"
        container="mapView"
        :zoom="7.2"
        mw="100%"
        mh="100%"
        :maxZoom="18"
      >
        <tz-toggle-map
          :base-list="configList"
          :is-note="true"
          :index="1"
          :offset="{ right: '510px', bottom: '1px' }"
        />
        <!-- 图例 -->
        <div
          class="map-tl-container"
          @mouseenter="handleRightIconEnter()"
          @mouseleave="handleRightIconleave()"
        >
          <div class="map-tl">
            <div class="map-tl-title">图例</div>
            <div
              class="key-content"
              v-for="(item, index) in examplesData"
              :key="index"
            >
              <img
                class="key-img"
                v-if="(levels < 10 && index < 3) || (levels <= 12 && index > 2)"
                :src="item.bgc"
                alt=""
              />
              <div
                class="key-img1"
                v-if="
                  (levels >= 10 && item.bgc2 && index < 3) ||
                  (levels > 12 && item.bgc2 && index > 2)
                "
                :style="{ background: item.bgc2 }"
              ></div>
              <!-- <div class="key-img1" v-if="levels > 12 && item.bgc2" :style="{ background: item.bgc2 }"></div> -->
              <span class="key-text">{{ item.name }}</span>
            </div>
          </div>
        </div>

        <div class="rightIcon" @mouseenter="handleRightIconEnter()">
          <img
            v-show="rightIcon"
            src="@/assets/images/left.png"
            alt=""
            class="imgleft"
            @click="handleCaretRight(true)"
          />
          <img
            v-show="!rightIcon"
            src="@/assets/images/right.png"
            alt=""
            class="imgright"
            @click="handleCaretRight(false)"
          />
        </div>
        <mapImage></mapImage>
      </tz-map>
      <div v-show="showEchart">
        <div
          v-for="(item, index) in echartData"
          :id="'echart_' + index"
          style="height: 100px; width: 100px; cursor: pointer"
          @click="
            echartClick(item);
            countyValue = item.value;
            form.county = item.value;
          "
          :key="index"
        ></div>
      </div>

      <!-- 云上选地搜索 -->
      <div
        class="tool-search"
        :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
      >
        <div class="tool-box-search">
          <div class="tool-box-search-input">
            <el-autocomplete
              placeholder="请输入行业、行政区划、地块名称、宗地编号"
              v-model="form.name"
              :fetch-suggestions="queryParkFormSearch"
              @select="handleParkFormSelect"
              style="width: 100%"
              clearable
            >
            </el-autocomplete>
          </div>
          <div class="tool-box-search-btn" @click="searchFrom">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div class="xzqh-tree" @click="xzqhIsActivate = !xzqhIsActivate">
          <el-popover placement="bottom-start" width="250" trigger="click">
            <el-tree
              :data="xzqhList"
              accordion
              @node-click="handleNodeClick"
              @getCurrentNode="handleCurrentClick"
              highlight-current
            ></el-tree>
            <div class="xzqh-tree-title" slot="reference">
              <div
                v-show="xzqhName"
                style="position: relative; width: 170px"
                @mouseenter="mouseenterShow = true"
                @mouseleave="mouseenterShow = false"
              >
                {{ xzqhName }}
                <i
                  v-show="mouseenterShow && xzqhName"
                  class="el-icon-circle-close"
                  style="position: absolute; right: 1px; top: 10px"
                  @click="
                    handleNodeClick(null);
                    getZoomInfos();
                  "
                ></i>
              </div>
              <div
                v-show="!xzqhName"
                style="color: #c0c4cc; padding-left: 10px"
              >
                请选择行政区划
              </div>
              <div>
                <i
                  style="margin-right: 7px; color: #c0c4cc"
                  v-show="!xzqhIsActivate && !mouseenterShow"
                  class="el-icon-arrow-down"
                ></i>
                <i
                  style="margin-right: 7px; color: #c0c4cc"
                  v-show="xzqhIsActivate && !mouseenterShow"
                  class="el-icon-arrow-up"
                ></i>
              </div>
            </div>
          </el-popover>
        </div>

        <!-- 土地用途 -->
        <div class="land-use">
          <el-cascader
            v-model="form.typeArr"
            placeholder="土地用途"
            ref="cascaderHandle"
            :options="tdytList"
            :props="{
              value: 'code',
              label: 'name',
              children: 'child',
            }"
            clearable
            style="width: 100px"
          ></el-cascader>
        </div>
        <!-- 面积 -->

        <el-popover
          placement="bottom"
          width="340"
          trigger="click"
          :offset="12"
          ref="popoverRef"
        >
          <div class="offer-area-form">
            <span style="font-size: 0.85rem; padding-left: 10px">
              面积（亩）：</span
            >
            <div style="width: 80px">
              <el-input
                v-model="form.areaMin"
                type="number"
                placeholder="最小面积"
                oninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </div>
            <span>-</span>
            <div style="width: 80px">
              <el-input
                v-model="form.areaMax"
                placeholder="最大面积"
              ></el-input>
            </div>
            <el-button
              size="mini"
              style="margin-left: 10px; color: #fff"
              type="primary"
              @click="getLands"
              >确定</el-button
            >
          </div>
          <div class="offer-area" slot="reference">
            <div
              v-if="!form.areaMin && !form.areaMax"
              @click="offerArea = !offerArea"
            >
              面积
            </div>
            <div
              v-else
              @mouseenter="offerAreaShow = true"
              @mouseleave="offerAreaShow = false"
              style="
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 100%;
              "
            >
              <div style="color: #409eff" v-show="form.areaMin || form.areaMax">
                {{ form.areaMin }}-{{ form.areaMax }}
              </div>

              <i
                class="el-icon-circle-close"
                v-show="offerAreaShow && (form.areaMin || form.areaMax)"
                style="color: #606266; font-size: 15px"
                @click="
                  form.areaMin = null;
                  form.areaMax = null;
                  offerAreaShow = false;
                  getLands();
                "
              ></i>
            </div>
            <i
              class="el-icon-arrow-down"
              v-show="!offerAreaShow && !offerArea"
            ></i>
            <i
              class="el-icon-arrow-up"
              v-show="!offerAreaShow && offerArea"
            ></i>
          </div>
        </el-popover>

        <!-- 行业 -->
        <div v-if="labelList.length > 0">
          <el-select
            placeholder="行业"
            v-model="form.industryType"
            @change="searchFrom"
            clearable
            style="width: 100px"
          >
            <el-option
              v-for="item in labelList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <!-- <el-cascader
          placeholder="行业"
          :options="labelList"
          v-model="form.label"
          @change="searchFrom"
          :props="{
            label: 'labelName',
            value: 'labelId',
          }"
          clearable
          style="width: 100px"
          @clearCheckedNodes="getZoomInfos()"
        ></el-cascader> -->
        </div>
        <div
          class="cb-btn"
          :style="{
            background: form.isReserve == 1 ? '#2090FF' : '',
            color: form.isReserve == 1 ? '#fff' : '',
          }"
          @click="
            form.isReserve == 1 ? (form.isReserve = '') : (form.isReserve = 1);
            form.current = 1;
            getLands();
            getSupplyPeriodList();
          "
        >
          储备土地
        </div>
      </div>
      <!-- 行政区划 -->
      <div
        class="tool-box-center"
        :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
      >
        <div style="display: flex; align-items: center">
          <div class="available">
            <el-tooltip
              class="item"
              effect="dark"
              placement="bottom"
              :open-delay="1000"
            >
              <div slot="content" style="width: 140px">
                经国务院或省政府批准，达到“净地”标准，已发布出让公告的地块或拟于三个月内出让（含已纳入住宅用地拟出让清单）的地块。
              </div>
              <div
                :class="offeringsIndex1 ? 'offerings-class1' : ''"
                class="available-item"
                @click="offerings1"
                :style="{ background: offeringsIndex1 ? '#02D64A' : '#fff' }"
              >
                <div
                  :style="{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }"
                >
                  <img
                    v-show="!offeringsIndex1"
                    class="imgStyle"
                    src="@/assets/images/ldkg.png"
                    alt=""
                  />
                  <img
                    v-show="offeringsIndex1"
                    class="imgStyle"
                    src="@/assets/images/ldkg-activate.png"
                    alt=""
                  />
                  <span
                    :class="offeringsIndex1 ? 'offerings-color' : ''"
                    :style="{
                      marginLeft: '5px',
                      color: offeringsIndex1 ? '#fff' : '#02D64A',
                    }"
                    >立等可供</span
                  >
                </div>
              </div>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              placement="bottom"
              :open-delay="1000"
            >
              <div slot="content" style="width: 140px">
                经国务院或省政府批准，拟于三个月后出让的地块。
              </div>
              <div
                :class="offeringsIndex3 ? 'offerings-class1' : ''"
                @click="offerings3"
                class="available-item"
                :style="{ background: offeringsIndex3 ? '#497AFF' : '#fff' }"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    v-show="!offeringsIndex3"
                    class="imgStyle"
                    src="@/assets/images/jhkg.png"
                    alt=""
                  />
                  <img
                    v-show="offeringsIndex3"
                    class="imgStyle"
                    src="@/assets/images/jhkg-activate.png"
                    alt=""
                  />
                  <span
                    :class="offeringsIndex3 ? 'offerings-color' : ''"
                    :style="{
                      marginLeft: '5px',
                      color: offeringsIndex3 ? '#fff' : '#497AFF',
                    }"
                    >计划可供</span
                  >
                </div>
              </div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              placement="bottom"
              :open-delay="1000"
            >
              <div slot="content" style="width: 140px">
                符合国土空间规划、控制性详细规划，满足用地报批要求，未来可用于项目建设的用地。
              </div>
              <div
                :class="offeringsIndex2 ? 'offerings-class1' : ''"
                @click="offerings2"
                class="available-item"
                :style="{ background: offeringsIndex2 ? '#FDBA32' : '#fff' }"
              >
                <div
                  :style="{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }"
                >
                  <img
                    v-show="!offeringsIndex2"
                    class="imgStyle"
                    src="@/assets/images/ghkg.png"
                    alt=""
                  />
                  <img
                    v-show="offeringsIndex2"
                    class="imgStyle"
                    src="@/assets/images/ghkg-activate.png"
                    alt=""
                  />
                  <span
                    :class="offeringsIndex2 ? 'offerings-color' : ''"
                    :style="{
                      marginLeft: '5px',
                      color: offeringsIndex2 ? '#fff' : '#FDBA32',
                    }"
                    >规划可用</span
                  >
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <transition name="slide-fade">
          <div v-show="show3" class="tool-toolbar-box">
            <!-- <el-popover
              width="350"
              trigger="click"
              placement="bottom"
              @hide="isParkExpand = true"
            > -->
            <!-- 园区列表 -->
            <transition name="el-fade-in-linear">
              <div
                class="park-list-box"
                id="tool-toolbar1"
                v-if="!isParkExpand"
              >
                <div class="table-box-title">园区（开发区）、滇中新区</div>
                <div class="table-box-search">
                  <div class="table-box-search-input">
                    <el-autocomplete
                      placeholder="请输入主导产业，行政区划，园区（开发区）名称"
                      v-model="parkForm.name"
                      :fetch-suggestions="queryParkFormSearch"
                      @select="handleParkFormSelect"
                      style="width: 100%"
                      clearable
                    >
                    </el-autocomplete>
                  </div>
                  <div class="table-box-search-btn" @click="getParkTable">
                    <i class="el-icon-search"></i>
                  </div>
                </div>
                <div
                  class="table-park scrollbar-definition"
                  v-if="parkList.length || parkLoading"
                  v-loading="parkLoading"
                >
                  <park-card-box
                    v-for="(item, index) in parkList"
                    :key="index"
                    :detailInfo="item"
                    :isAtive="item.isAtive"
                    :nowIndex="index"
                    @onDetail="detailBtnPark"
                  ></park-card-box>
                </div>
                <div
                  class="search-box-box"
                  v-if="!parkList.length && !parkLoading"
                >
                  <div class="search-box-box-top">
                    <img src="../../assets/images/common/3.png" alt="" />
                  </div>
                  <div class="search-box-box-center">
                    <p>抱歉，没有找到符合条件的园区</p>
                  </div>
                </div>
                <div class="park-pagination" v-if="parkList.length">
                  <el-pagination
                    :pager-count="5"
                    :current-page="parkForm.current"
                    @size-change="handleParkSizeChange"
                    @current-change="handleParkCurrentChange"
                    :page-size="parkForm.size"
                    layout=" prev, pager, next,total "
                    :total="parkForm.total"
                  ></el-pagination>
                </div>
              </div>
            </transition>
            <div
              id="content-list"
              class="park-button"
              @click="parkExpand"
              :style="{ color: isParkExpand == false ? '#2C83F6' : '' }"
              slot="reference"
            >
              <img
                v-show="isParkExpand"
                class="imgStyle"
                src="../../assets/images/yq.png"
                alt=""
              />
              <img
                v-show="!isParkExpand"
                class="imgStyle"
                src="../../assets/images/yq-activate.png"
                alt=""
              />
              <span
                :style="{
                  fontSize: '14px',
                  marginleft: '10px',
                  color: isParkExpand
                    ? 'rgb(192, 196, 204)'
                    : 'rgb(44, 131, 246)',
                }"
                >园区</span
              >
            </div>
            <!-- </el-popover> -->
            <!-- 项目招商列表 -->
            <!-- <el-popover
              placement="bottom"
              width="350"
              trigger="click"
              @hide="isProjectpand = true"
            >
              
              <div
                :class="[
                ]"
              >
                <div class="table-box-search">
                  <div class="table-box-search-input">
                    <el-autocomplete
                      placeholder="请输入行业、行政区划、开发区、项目名称"
                      v-model="projectForm.projectName"
                      :fetch-suggestions="queryParkFormSearch"
                      @select="handleParkFormSelect"
                      style="width: 100%"
                      clearable
                    >
                    </el-autocomplete>
                  </div>
                  <div class="table-box-search-btn" @click="getprojectLsist">
                    <i class="el-icon-search"></i>
                  </div>
                </div>
                <div
                  class="table-park scrollbar-definition"
                  v-if="projectList.length || projectLoading"
                  v-loading="projectLoading"
                >
                  <projectcardBox
                    v-for="(item, index) in projectList"
                    :key="index"
                    :detailInfo="item"
                    :isAtive="item.isAtive"
                    :nowIndex="index"
                    @onDetail="detailBtnProjcet"
                  ></projectcardBox>
                </div>
                <div
                  class="search-box-box"
                  v-if="!projectList.length && !projectLoading"
                >
                  <div class="search-box-box-top">
                    <img src="../../assets/images/common/3.png" alt="" />
                  </div>
                  <div class="search-box-box-center">
                    <p>抱歉，没有找到符合条件的项目招商</p>
                  </div>
                </div>
                <div class="park-pagination" v-if="projectList.length">
                  <el-pagination
                    :pager-count="5"
                    :current-page="projectForm.current"
                    @size-change="handleProjectSizeChange"
                    @current-change="handleProjectCurrentChange"
                    :page-size="projectForm.size"
                    layout=" prev, pager, next,total "
                    :total="projectForm.total"
                  >
                  </el-pagination>
                </div>
              </div> -->
            <!-- <div
              class="project-button"
              @click="(isProjectpand = !isProjectpand), (isParkExpand = true)"
              :style="{ color: isProjectpand == false ? '#2C83F6' : '' }"
              slot="reference"
            >
              <img
                v-show="isProjectpand"
                class="imgStyle"
                src="../../assets/images/zsxm.png"
                alt=""
              />
              <img
                v-show="!isProjectpand"
                class="imgStyle"
                src="../../assets/images/zsxm-activate.png"
                alt=""
              />
              <span
                :style="{
                  fontSize: '14px',
                  marginleft: '10px',
                  color: isProjectpand
                    ? 'rgb(192, 196, 204)'
                    : 'rgb(44, 131, 246)',
                }"
                >项目招商</span
              >
            </div> -->
            <!-- </el-popover> -->
            <div class="layer">
              <layer
                :map-view="mapView"
                @callBackCheckNode="callBackCheckNode"
              ></layer>
            </div>
            <div class="tool">
              <tools :map-view="mapView"></tools>
            </div>
          </div>
        </transition>
        <i @click="unfoldTool" class="icon-unfold" :class="unfold"></i>
        <!-- <div class="land-need-box">
        <span class="land-need-box-span1">未找到地块？</span>
        <span class="land-need-box-span2" @click="releaseNeed">提交需求！</span>
      </div> -->
      </div>

      <!-- 地块列表 -->
      <div
        class="dklist"
        v-show="DKIsActivate && isLandExpand"
        :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
      >
        <div style="margin-left: 10px">共找到{{ form.total }}个地块</div>
        <div
          style="margin-right: 10px; cursor: pointer"
          v-show="isLandExpand"
          @click="isLandExpand = false"
        >
          展开 <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <el-collapse-transition>
        <div
          :class="['search-box1']"
          v-show="!isLandExpand"
          :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
        >
          <!-- 查询 -->
          <div class="table-box-title">
            <div class="shrink">
              <div
                style="margin-right: 10px; cursor: pointer"
                v-show="!isLandExpand"
                @click="isLandExpand = true"
              >
                收起 <i class="el-icon-arrow-up"></i>
              </div>
            </div>
          </div>

          <div
            class="land-list scrollbar-definition"
            v-if="landList.length || landLoading"
            v-loading="landLoading"
          >
            <land-card-box
              v-for="(item, index) in landList"
              :key="index"
              :detailInfo="item"
              :is-atives="item.isAtive"
              :nowIndex="index"
              @onDetail="detailBtnLand"
            ></land-card-box>
          </div>
          <div class="search-box-box" v-if="!landList.length && !landLoading">
            <div class="search-box-box-top">
              <img src="../../assets/images/common/3.png" alt="" />
            </div>
            <div class="search-box-box-center">
              <p>抱歉，没有找到符合条件的地块</p>
              <p>你可以去：</p>
            </div>
            <div class="search-box-box-btn" @click="releaseNeed">提交需求</div>
          </div>
          <div class="search-box-list-page" v-if="landList.length">
            <!-- :page-sizes="[10, 20, 40, 80]" -->
            <el-pagination
              :pager-count="5"
              :current-page="form.current"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="form.size"
              layout=" prev, pager, next,total "
              :total="form.total"
            ></el-pagination>
          </div>
        </div>
      </el-collapse-transition>

      <!--  影像  -->
      <div
        v-if="influence"
        class="new-influence"
        :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
      >
        <influence
          @closeInfluence="closeInfluence"
          :message="$message"
        ></influence>
      </div>
    </div>
  </div>
</template>
<script>
import mapImage from "@/components/mapImage";
import Layer from "@/components/currency/layer";
import Tools from "@/components/currency/tools";
import ParkCardBox from "@/components/currency/parkCardBox";
import LandCardBox from "@/components/currency/cardBox";
import projectcardBox from "@/components/currency/projectcardBox.vue";
import Need from "@/components/currency/need";
import { addChartsOverlay } from "../../pulgin/addChartOverlayPulgin";
import {
  dictionaries,
  getXzqhList,
  getTypeList,
  getCountyShp,
} from "@/api/common";
import Concert from "@/map/Convert";
import {
  getParkPage,
  landList,
  getParkDetail,
  getLandInfoTwo,
  getShp,
  searchDefault,
  searchParkInfo,
  getChunkCenterList,
  getAllShpByScope,
  getSupplyPeriod,
  getLevePark,
  getProjectShp,
  getParcelAll,
  parkCenterPoint,
  getParkAllShp,
  getParkShp,
  getQxShpByScope,
  getCountyChildShp,
  getIndustryList,
  getParkCodeShp,
} from "@/api/setting/investment";
import { projectList, projectIDLIST } from "@/api/setting/project.js";

import information from "@/components/promotion/information.vue";
import Influence from "@/components/promotion/influence.vue";
import landDetailInfo from "@/map/landDetailInfo.js";
import parkDeatilInfo from "@/map/parkDeatilInfo.js";
import projectInfo from "@/map/projectInfo.js";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom.js";
import { cleanChartsOverlayId } from "@/pulgin/addChartOverlayPulgin";
export default {
  name: "need-land",

  components: {
    Influence,
    Layer,
    Tools,
    LandCardBox,
    ParkCardBox,
    Need,
    information,
    projectcardBox,
    mapImage,
  },
  data() {
    return {
      screenIndexWidth: null,
      rightIcon: true,
      mouseenterShow: false,
      DKIsActivate: false,
      oldLevel: 0, //历史等级
      statisticsExpend: false,
      offerArea: false, //可供面积
      offerAreaShow: false,
      mapEvents: null,
      position: [101.72641675208839, 25.141086091950477],
      height: document.body.clientHeight - 190 + "px",
      mapView: undefined,
      xzqhList: [],
      xzqhName: "",
      xzqhIsActivate: false,
      configList: mapConfig.configList,
      regionValue: [],
      searchValue: null,
      countyValue: "", //行政区划
      type: 1, //查询类型
      //园区查询
      form: {
        current: 1,
        size: 5,
        total: 0,
        name: "",
        areaMin: undefined,
        areaMax: undefined,
        type: "",
        typeArr: [],
        supplyPeriod: null,
        industryType: null,
        parkCode: "",
        transaction: 1,
        isReserve: "",
      },
      //记录用地画范围id
      landMap: [],
      // 记录项目招商画id
      proMap: [],
      //用地查询
      landForm: {
        current: 1,
        size: 10,
        total: 0,
      },
      labelList: [],
      landLoading: false, //地块列表加载
      parkLoading: false, //园区列表加载
      projectLoading: false, //项目招商加载
      parkList: [], //园区数组
      landList: [], //用地数组
      projectList: [], //项目招商数组
      isLandBtottom: false, //用地是否到底
      isParkBtottom: false, //园区是否到底
      isExtranet: true,
      frist: true, //用地是否第一次加载
      fristPark: true, //园区是否第一次加载
      detailShowPark: false, //是否显示园区弹框
      detailParkInfo: {}, //园区详情数据
      investmentInfo: {}, //招商信息
      landShow: false,
      landInfo: {}, //地块详情
      landShp: {}, //用地图形文件
      projectShp: {}, //项目招商图形文件
      projectInfo: {},
      isReleaseNeed: false, //是否显示提交需求
      checkNodeData: [], //已勾选图层数据
      tdytList: [],
      typeStatus: "", //地块类型
      isEnd: 0,
      layerArr: layerConfig.parkDistributionLayer.layerIndex, //园区分布查询layerIndex
      layerIndex: 0, //园区分布查询起始位置
      area: [30, 60],
      parkForm: {
        total: 0,
        size: 6,
        current: 1,
        name: "",
      },
      projectForm: {
        approvalStatus: null,
        total: 0,
        size: 6,
        current: 1,
        projectName: "",
        county: "",
      },
      isShowlandBox: false, //控制用地筛选条件的显示
      isLandExpand: true, //控制用地伸缩
      isParkExpand: true, //控制园区伸缩
      isProjectpand: true, //控制项目招商显示
      fileShp: {}, //跳转图形数据
      isSkip: false, //是否是跳转
      isSkip1: false,
      unfold: "el-icon-s-unfold",
      show3: true,
      // 图例
      examplesData: [
        {
          name: "滇中新区",
          bgc: require("@/assets/newImg/dzxq.png"),
          bgc2: "#0f57a4",
        },
        {
          name: "国家级开发区",
          bgc: require("@/assets/newImg/gjjkfq.png"),
          bgc2: "#A632FF",
        },
        {
          name: "省级开发区",
          bgc: require("@/assets/newImg/sjkfq.png"),
          bgc2: "#FF7206",
        },
        // {
        //   name: "其他开发区",
        //   bgc: require("@/assets/newImg/qtkfq.png"),
        //   bgc2: "#03B9CD",
        // },
        {
          name: "立等可供",
          bgc: require("@/assets/images/tl1.png"),
          bgc2: "#02D64A",
          bgc1: "#02d64a80",
        },
        {
          name: "计划可供",
          bgc: require("@/assets/images/tl3.png"),
          bgc2: "#497AFF",
          bgc1: "#497aff80",
        },
        {
          name: "规划可用",
          bgc: require("@/assets/images/tl2.png"),
          bgc2: "#FFAE11",
          bgc1: "#ffae1180",
        },
      ],
      parkImgList: [
        {
          name: "滇中新区",
          bgc: require("@/assets/newImg/dzxq.png"),
          bgc1: "#0f57a4cc",
        },
        {
          name: "国家级开发区",
          bgc: require("@/assets/newImg/gjjkfq.png"),
          bgc1: "#a733ffcc",
        },
        {
          name: "省级开发区",
          bgc: require("@/assets/newImg/sjkfq.png"),
          bgc1: "#f66300e8",
        },
        {
          name: "其他开发区",
          bgc: require("@/assets/newImg/qtkfq.png"),
          bgc1: "#03b9cdd6",
        },
      ], //园区
      navigationIndex: null,
      where: "",
      listData: {}, //用地详情数据
      parkIdActive: null, //园区当前选中信息id
      landSearchList: [], //缓存搜索记录用地
      parkSearchList: [], //缓存搜索记录园区
      queryData: [
        { name: "商业用地", color: "#4BA4DE" },
        { name: "住宅用地", color: "#50BAD7" },
        { name: "工矿仓储用地", color: "#FC8069" },
        { name: "其他用地", color: "#F6B12C" },
      ],
      queryForm: {
        name: "",
        num1: 0,
        num2: 0,
      },
      economic: [
        { name: "国家级开发区", num: 21, color: "#A632FF" },
        { name: "省级开发区", num: 21, color: "#005BE7" },
        { name: "其他开发区", num: 21, color: "#45C41A" },
      ],
      offeringsIndex1: false,
      offeringsIndex2: false,
      offeringsIndex3: false,
      offeringsIndex4: false,
      parcelData: {
        parcelSum: 0,
        parcelAreaSum: 0,
        countryPark: 0,
        otherPark: 0,
        provincePark: 0,
      },
      landUseIndex: 0,
      root: null,
      rootPark: null,
      rootProject: null,
      rootCensus: null,
      influence: false,
      landImgList: [
        require("@/assets/images/land/ldkg.png"),
        require("@/assets/images/land/jqkg.png"),
        require("@/assets/images/land/jhkg.png"),
      ], //供应期限
      echartData: [],
      showEchart: false,
      echartObjs: [],
      markerIds: [],
      chunkIds: [],
      levels: 7,
      isPressing: false, //监听鼠标长按移动
      startX: 0, //监听鼠标长按移动
      startY: 0, //监听鼠标长按移动
      endX: 0, //监听鼠标长按移动
      endY: 0, //监听鼠标长按移动
      projectlayerId: "",
    };
  },
  watch: {
    //监听可供变化
    "form.supplyPeriod": function (newVal, oldVal) {
      let zoomObj = this.mapView.getZoomInfo();
      let level = Math.round(zoomObj.zoom);
      if (newVal) {
        //画表
        if (level <= 8 && level >= 7) {
          this.removeMarkers();
          this.removeChunks();
          this.removeEcharts();
          if (this.echartObjs.length == 0) {
            let index =
              newVal == 1 ? 0 : newVal == 3 ? 1 : newVal == 4 ? 2 : null;
            for (let i in this.echartData) {
              //当统计值为0时不用渲染表
              // if (this.echartData[i].dataList[index]) {

              // }
              this.addEchart(this.echartData[i], i);
            }
          }
        }
      } else {
        //画表
        if (level <= 8 && level >= 7) {
          this.removeMarkers();
          this.removeChunks();
          this.removeEcharts();
          if (this.echartObjs.length == 0) {
            for (let i in this.echartData) {
              this.addEchart(this.echartData[i], i);
            }
          }
        }
      }
      //画点
      if (level > 8 && level <= 12) {
        this.removeChunks();
        this.removeEcharts();
        //删除之前渲染的点
        this.removeMarkers();
        if (this.markerIds.length == 0) {
          this.setChunkCenter();
        }
      }
      //画面
      if (level > 12) {
        this.removeMarkers();
        this.removeEcharts();
        //删除之前画的面
        this.removeChunks();
        this.setChunks();
      }
    },

    //监听地块名称搜索
    "form.name": function (val) {
      if (val) {
        let list = JSON.parse(sessionStorage.getItem("landSearchList"))
          ? JSON.parse(sessionStorage.getItem("landSearchList"))
          : [];
        if (list.length) {
          let index = list.findIndex((item) => item.value == val);
          if (index == -1) {
            list.push({ value: val });
            sessionStorage.setItem("landSearchList", JSON.stringify(list));
          }
        } else {
          list.push({ value: val });
          sessionStorage.setItem("landSearchList", JSON.stringify(list));
        }
        this.landSearchList = JSON.parse(
          sessionStorage.getItem("landSearchList")
        )
          ? JSON.parse(sessionStorage.getItem("landSearchList"))
          : [];
        this.form.current = 1;
        this.getLands();
      } else {
        this.form.current = 1;
        this.getLands();
      }
    },
    // 监听项目招商搜索
    "projectForm.projectName": function (val) {
      if (val) {
        let list = JSON.parse(sessionStorage.getItem("projectList"))
          ? JSON.parse(sessionStorage.getItem("projectList"))
          : [];
        if (list.length) {
          let index = list.findIndex((item) => item.value == val);
          if (index == -1) {
            list.push({ value: val });
            sessionStorage.setItem("projectList", JSON.stringify(list));
          }
        } else {
          list.push({ value: val });
          sessionStorage.setItem("projectList", JSON.stringify(list));
        }
        this.parkSearchList = JSON.parse(sessionStorage.getItem("projectList"))
          ? JSON.parse(sessionStorage.getItem("projectList"))
          : [];
        this.projectForm.current = 1;
        this.getprojectLsist();
      } else {
        this.parkForm.current = 1;
        this.getprojectLsist();
      }
    },
    //监听园区名称搜索
    "parkForm.name": function (val) {
      if (val) {
        let list = JSON.parse(sessionStorage.getItem("parkSearchList"))
          ? JSON.parse(sessionStorage.getItem("parkSearchList"))
          : [];
        if (list.length) {
          let index = list.findIndex((item) => item.value == val);
          if (index == -1) {
            list.push({ value: val });
            sessionStorage.setItem("parkSearchList", JSON.stringify(list));
          }
        } else {
          list.push({ value: val });
          sessionStorage.setItem("parkSearchList", JSON.stringify(list));
        }
        this.parkSearchList = JSON.parse(
          sessionStorage.getItem("parkSearchList")
        )
          ? JSON.parse(sessionStorage.getItem("parkSearchList"))
          : [];
        this.parkForm.current = 1;
        this.getParkTable();
      } else {
        this.parkForm.current = 1;
        this.getParkTable();
      }
    },
    area: {
      deep: true,
      handler(newVal) {
        this.form.areaMin = newVal[0];
        this.form.areaMax = newVal[1];
      },
    },

    projectShp: {
      deep: true,
      handler() {
        this.projectLocation(this.projectShp.shapeInfo, this.projectInfo);
      },
    },
    // 监听项目招商显隐
    isProjectpand: {
      deep: true,
      handler(newVal) {},
    },

    // 行政区划变化时，请求用地、园区列表
    countyValue: function (val) {
      if (val) {
        this.getParkTable();
        this.getLands();
        // this.removeEcharts();
        // this.getSupplyPeriodList()
      } else {
        this.landList = [];
        this.parkList = [];
      }
    },
    "form.typeArr": {
      deep: true,
      handler(newVal) {
        // this.removeEcharts();
        // this.getSupplyPeriodList()
        if (newVal) {
          if (newVal.length) {
            this.form.type = newVal.join(",");
            this.searchFrom();
            this.removeEcharts();
            this.getSupplyPeriodList();
          } else {
            this.form.type = "";
            this.searchFrom();
            this.removeEcharts();
            this.getSupplyPeriodList();
          }
        }
      },
    },
    "form.industryType": {
      deep: true,
      handler(newVal) {
        this.removeEcharts();
        this.getSupplyPeriodList();
      },
    },
    influence: function (val) {
      // 获取地图自带影像
      // const toggle = document.querySelector(".tz-toggle-layout");
      // if (val) {
      //   toggle.classList.add("bottom-toggle-layout");
      //   toggle.classList.remove("top-toggle-layout");
      // } else {
      //   toggle.classList.add("top-toggle-layout");
      //   toggle.classList.remove("bottom-toggle-layout");
      // }
      // 获取图例
      // const keyMap = document.querySelector(".map-tl");
      // if (val) {
      //   keyMap.style.bottom = "115px";
      //   keyMap.style.transition = "all 0.5s linear";
      // } else {
      //   keyMap.style.bottom = "10px";
      //   keyMap.style.transition = "all 0.5s linear";
      // }
    },
    form: {
      handler: function (newVal, oldVal) {
        this.getZoomInfos();

        var object = {
          areaMax: null,
          areaMin: null,
          county: "",
          current: 1,
          name: "",
          parkCode: "",
          size: 5,
          supplyPeriod: null,
          total: this.form.total,
          type: "",
          typeArr: [],
          transaction: 1,
        };

        var object1 = {
          current: 1,
          size: 5,
          total: this.form.total,
          name: "",
          type: "",
          typeArr: [],
          supplyPeriod: null,
          label: null,
          labelName: "",
          parkCode: "",
          transaction: 1,
        };

        var object2 = {
          areaMax: null,
          areaMin: null,
          county: "",
          current: 1,
          name: "",
          parkCode: "",
          size: 5,
          supplyPeriod: null,
          total: this.form.total,
          type: "",
          typeArr: [],
          transaction: 1,
        };
        var object3 = {
          areaMax: null,
          areaMin: null,
          current: 1,
          name: "",
          parkCode: "",
          size: 5,
          supplyPeriod: null,
          total: this.form.total,
          type: "",
          typeArr: [],
          transaction: 1,
        };
        var object4 = {
          current: 1,
          size: 5,
          total: this.form.total,
          name: "",
          type: "",
          typeArr: [],
          supplyPeriod: null,
          label: null,
          labelName: "",
          county: "",
          parkCode: "",
          transaction: 1,
        };
        var object5 = {
          current: 1,
          size: 5,
          total: this.form.total,
          name: "",
          type: "",
          typeArr: [],
          supplyPeriod: null,
          label: "",
          labelName: "",
          county: "",
          parkCode: "",
          transaction: 1,
        };
        var object6 = {
          current: 1,
          size: 5,
          total: 0,
          name: "",
          type: "",
          typeArr: [],
          supplyPeriod: null,
          industryType: null,
          parkCode: "",
          transaction: 1,
        };
        if (
          JSON.stringify(newVal) == JSON.stringify(object) ||
          JSON.stringify(newVal) == JSON.stringify(object1) ||
          JSON.stringify(newVal) == JSON.stringify(object2) ||
          JSON.stringify(newVal) == JSON.stringify(object3) ||
          JSON.stringify(newVal) == JSON.stringify(object4) ||
          JSON.stringify(newVal) == JSON.stringify(object5) ||
          JSON.stringify(newVal) == JSON.stringify(object6)
        ) {
          this.DKIsActivate = false;
          this.isLandExpand = true;
          this.clearFrom();
          return;
        } else {
          this.DKIsActivate = true;
          return;
        }
      },
      immediate: true,
      deep: true,
    },
    landList: {
      handler: function (newVal) {
        if (newVal.length >= 1) {
          this.isLandExpand = false;
        }
        //  console.log(newVal)
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事件
    this.concert = new Concert();
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度

    //监听注册事件
    this.$eventBus.on("historicalChanges", () => {
      this.influence = true;
    });
    this.$eventBus.on("refreshLandList", () => {
      this.getLands();
    });
    //监听图层变化
    this.$eventBus.on("layerChange", (val) => {
      let zoomObj = this.mapView.getZoomInfo();
      let level = Math.round(zoomObj.zoom);
      this.levels = level;
      this.watchFun(level);
    });
    this.$eventBus.on("removeCharts", (val) => {
      let zoomObj = this.mapView.getZoomInfo();
      let level = Math.round(zoomObj.zoom);
      //当图层选择取消显示用地，且等级刚好等于聚合图显示层级时
      if (level <= 8 && level >= 7) {
        this.removeEcharts();
      }
    });
    //推荐内容获取
    this.landSearchList = JSON.parse(sessionStorage.getItem("landSearchList"))
      ? JSON.parse(sessionStorage.getItem("landSearchList"))
      : [];
    this.parkSearchList = JSON.parse(sessionStorage.getItem("parkSearchList"))
      ? JSON.parse(sessionStorage.getItem("parkSearchList"))
      : [];
    if (!this.landSearchList.length) {
      this.getLandSearchDefault();
    }
    if (!this.parkSearchList.length) {
      this.getParkSearchDefault();
    }
    this.getXzqh();
    this.$nextTick(() => {
      this.initMap();

      let data =
        JSON.parse(sessionStorage.getItem("landInfoDetail")) ||
        JSON.parse(sessionStorage.getItem("parkInfoDetail")) ||
        JSON.parse(sessionStorage.getItem("projectInfoDetail")) ||
        null;
      if (data != null) {
        // 当定位到地块时，不进行默认的全省定位
        if (data.type == "land") {
          this.form.name = data.name;
          this.getLandDetail(data.id); //查询地块 地图范围
          this.getLands(); //查询地块列表
          this.getParkTable(); // 查询园区列表
          this.isSkip = true;
          sessionStorage.removeItem("landInfoDetail"); // 删除 session值
        } else if (data.type == "project") {
          this.handleDetailsLocation(data.data, true, 0);
          sessionStorage.removeItem("projectInfoDetail"); // 删除 session值
        } else {
          this.parkForm.name = data.name;
          this.mapView.removeLayer("parkActiveLayerId"); //移除选中园区图层
          this.getParkShpInfo(data.id, true);

          this.getLands(); //查询地块列表
          this.getParkTable(); // 查询园区列表
          this.isSkip1 = true;
          sessionStorage.removeItem("parkInfoDetail"); // 删除 session值
        }
      } else {
        this.getParkTable(); // 查询园区列表
        // this.regionValue = ["53"];
        // this.changeRegion(this.regionValue);
      }
      this.getSupplyPeriodList();
    });
    this.gettdlx();

    // 获取行业信息
    getIndustryList().then((res) => {
      if (res.data.success) {
        this.labelList = res.data.data;
        // this.projectForm.total = res.data.data.total;
      }
    });
    // 获取项目招商列表
    // this.getprojectLsist();
  },
  activated() {
    let data =
      JSON.parse(sessionStorage.getItem("landInfoDetail")) ||
      JSON.parse(sessionStorage.getItem("parkInfoDetail")) ||
      null;
    if (data != null) {
    }
  },
  methods: {
    getZoomInfos() {
      this.$nextTick(() => {
        // this.levels = null;
        // this.oldLevel = null;
        let zoomObj = this.mapView.getZoomInfo();
        let level = Math.round(zoomObj.zoom);
        this.levels = level;

        this.watchFun(level);
      });
    },
    drawParkSpot() {
      parkCenterPoint().then((res) => {
        if (res.data.success) {
          //预防数据还未请求成功，地图层级已变化到不需要画园区点的情况
          if (this.levels <= 8 || this.levels >= 10) {
            return false;
          }
          this.mapView.removeLayer("parkPointLayerId"); //清除上一次渲染的地块
          let data = res.data.data;
          data.forEach((item) => {
            let geometry = {
              type: "Point",
              coordinates: [item.lng, item.lat],
            };
            this.$set(item, "geometry", geometry);
          });

          let geojson = this.concert.toGeoJson(
            data,
            "geometry",
            [
              "fromDataName",
              "id",
              "parkLevel",
              "lng",
              "lat",
              "fromDataId",
              "parkCode",
            ],
            4490
          );
          this.mapView.addGeojsonMapLayer(
            geojson,
            "parkPointLayerId",
            layerData[1].layerIndex,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let id = "spot_" + properties.fromDataId;
              let center = [properties.lng, properties.lat];
              let imgUrl = "";
              if (properties.parkCode != "DZXQ") {
                let index = Number(properties.parkLevel);
                imgUrl = this.parkImgList[index].bgc;
              } else {
                imgUrl = this.parkImgList[0].bgc;
              }

              feature.setProperties({
                id: id,
                center: center,
              });
              return this.mapView.setPointStyle("", imgUrl, 1);
            }
          );
        }
        this.isShowPrakSpot = true;
      });
    },
    //清除园区点
    removePrakSpot() {
      this.mapView.removeLayer("parkPointLayerId");
    },
    //画园区面
    drawParkFace() {
      let data = this.mapView.getViewExtent(); //获取视图范围
      let scope = [
        [data[0], data[3]],
        [data[2], data[3]],
        [data[2], data[1]],
        [data[0], data[1]],
        [data[0], data[3]],
      ];
      let obj = {
        scope: {
          type: "MultiPolygon",
          coordinates: [[scope]],
        },
      };
      getParkAllShp(obj).then((res) => {
        if (res.data.success) {
          //预防数据还未请求成功，地图层级已变化到不需要画园区面的情况
          if (this.levels < 10) {
            return false;
          }
          this.mapView.removeLayer("parkLayerId"); //清除上一次渲染的地块
          let list = res.data.data;
          // list.forEach((item) => {
          //   let parkId = "parkId_" + item.id;
          //   this.$set(item, "parkId", parkId);
          // });
          let geojson = this.concert.toGeoJson(
            list,
            "geom",
            ["parkName", "id", "parkLevel", "lng", "lat", "parkId", "parkCode"],
            4490
          );

          this.mapView.addGeojsonMapLayer(
            geojson,
            "parkLayerId",
            layerData[1].layerIndex,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();

              let id = "parkId_" + properties.parkId;
              let center = [properties.lng, properties.lat];
              feature.setProperties({ id: id, center: center });
              let fillColor = "";
              if (properties.parkCode != "DZXQ") {
                let index = Number(properties.parkLevel);
                fillColor = this.parkImgList[index].bgc1;
              } else {
                fillColor = this.parkImgList[0].bgc1;
              }

              return this.mapView.setPolygonStyle(
                properties.parkName,
                "rgba(0,0,0,0)",
                fillColor,
                "#fff"
              );
            }
          );
        }
      });
    },
    //清除园区点
    removePrakAllShp() {
      this.mapView.removeLayer("parkLayerId");

      //清除园区面详情弹框
      cleanChartsOverlayId("parkDetailInfo");
      //移除选中园区图层
      this.mapView.removeLayer("parkActiveLayerId");
    },
    //获取行政区划统计数据
    getSupplyPeriodList() {
      let obj = {
        minArea: this.form.areaMin,
        maxArea: this.form.areaMax,
        type: this.form.type,
        industryType: this.form.industryType,
        isReserve: this.form.isReserve,
      };
      getSupplyPeriod(obj).then((res) => {
        if (res.data.success) {
          this.addMovedEvent();
          this.echartData = res.data.data;
          for (let i in this.echartData) {
            //当统计值为0时不用渲染表
            this.addEchart(this.echartData[i], i);
          }
        }
      });
    },
    //监听层级
    addMovedEvent() {
      let me = this;
      this.mapView.addMoveendCallBack(function (res) {
        // me.isLandExpand = true;
        let zoomObj = me.mapView.getZoomInfo();
        let level = Math.round(zoomObj.zoom);
        me.levels = level;
        // me.drawShp(level); //画行政区划图层
        if (me.oldLevel == level && level <= 12) {
          return false;
        }
        me.watchFun(level);
      });
    },
    drawShp(level) {
      if (isRenderingXzqh) {
        if (level >= 10) {
          let data = this.mapView.getViewExtent(); //获取视图范围
          let scope = [
            [data[0], data[3]],
            [data[2], data[3]],
            [data[2], data[1]],
            [data[0], data[1]],
            [data[0], data[3]],
          ];
          let obj = {
            scope: {
              type: "MultiPolygon",
              coordinates: [[scope]],
            },
          };

          getQxShpByScope(obj).then((res) => {
            if (res.data.success) {
              let countyShpList = res.data.data;
              this.mapView.removeLayer("countyDistribution");
              let geojson = this.concert.toGeoJson(
                countyShpList,
                "geom",
                ["county", "id", "countyName", "lng", "lat", "fromDataName"],
                4490
              );
              this.mapView.addGeojsonMapLayer(
                geojson,
                "countyDistribution",
                100,
                0.7,
                undefined,
                undefined,
                (feature) => {
                  let properties = feature.getProperties();
                  let id = "county_" + properties.county;
                  feature.setProperties({ id: id });
                  let fillColor = xqjColorMatching[properties.county]; //填充色
                  return this.mapView.setPolygonStyle(
                    properties.fromDataName,
                    "#fff",
                    fillColor,
                    "#fff",
                    "#fff"
                  );
                }
              );
            }
          });
        } else {
          getCountyChildShp({ county: "53" }).then((res) => {
            if (res.data.success) {
              let countyShpList = res.data.data;
              this.mapView.removeLayer("countyDistribution");
              let geojson = this.concert.toGeoJson(
                countyShpList,
                "geom",
                ["county", "id", "countyName", "lng", "lat"],
                4490
              );
              systemConfig.mapApi.addGeojsonMapLayer(
                geojson,
                "countyDistribution",
                100,
                0.7,
                undefined,
                undefined,
                (feature) => {
                  let properties = feature.getProperties();
                  let id = "county_" + properties.county;
                  feature.setProperties({ id: id });
                  let fillColor = countyColorMatching[properties.county]; //填充色
                  return systemConfig.mapApi.setPolygonStyle(
                    properties.countyName,
                    "#5a6069",
                    fillColor,
                    "#fff",
                    "#fff"
                  );
                }
              );
            }
          });
        }
      }
    },
    watchFun(level) {
      let me = this;
      me.oldLevel = level;
      if (level > 8) {
        me.mapView.setLayerVisible("countyDistribution", false);
      }
      if (level < 9 && layerData[2].isShow) {
        me.mapView.setLayerVisible("countyDistribution", true);
      }
      //当小于7层级时，移除表
      if (level < 7) {
        me.removeEcharts();
      }
      //画表
      if (level <= 8 && level >= 7) {
        me.removeMarkers();
        me.removeChunks();

        if (me.echartObjs.length == 0 && layerData[0].isShow) {
          for (let i in me.echartData) {
            me.addEchart(me.echartData[i], i);
          }
        }
      }
      //画点
      if (level > 8 && level <= 12) {
        me.removeChunks();
        me.removeEcharts();
        //me.removeChunks();

        if (me.markerIds.length == 0 && layerData[0].isShow) {
          me.setChunkCenter();
        }
      }
      //画面
      if (level > 12) {
        me.removeMarkers();
        me.removeEcharts();
        if (layerData[0].isShow) {
          me.setChunks();
        }
      }

      //画园区点
      if (level < 10 && level > 8) {
        me.removePrakAllShp(); //清除面
        if (layerData[1].isShow) {
          me.drawParkSpot(); //画点
        }
      }
      //画园区面
      if (level >= 10) {
        me.removePrakSpot(); //清除点
        if (layerData[1].isShow) {
          me.drawParkFace(); //画面
        }
      }
      //清除园区要素
      if (level <= 8) {
        me.removePrakSpot(); //清除点
        me.removePrakAllShp(); //清除面
      }
    },
    setChunkCenter() {
      let me = this;
      let params = Object.assign(this.form, {
        county: this.countyValue,
        minArea: this.form.areaMin,
        maxArea: this.form.areaMax,
        type: this.form.type,
        industryType: this.form.industryType,
        isReserve: this.form.isReserve,
      });
      getParcelAll(params).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          //预防数据还未请求成功，地图层级已变化到不需要画点的情况
          if (this.levels > 12 || this.levels <= 8) {
            return false;
          }
          this.mapView.removeLayer("landPointLayerId");
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["fromDataName", "id", "supplyPeriod", "lng", "lat", "fromDataId"],
            4490
          );
          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "landPointLayerId",
            layerData[0].layerIndex,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let id = "marker_" + properties.fromDataId;
              let fillColor =
                properties.supplyPeriod == 1
                  ? this.examplesData[3].bgc1
                  : properties.supplyPeriod == 3
                  ? this.examplesData[4].bgc1
                  : properties.supplyPeriod == 4
                  ? this.examplesData[5].bgc1
                  : ""; //填充色

              let center = [properties.lng, properties.lat];
              let imgUrl =
                properties.supplyPeriod == 1
                  ? this.examplesData[3].bgc
                  : properties.supplyPeriod == 3
                  ? this.examplesData[4].bgc
                  : properties.supplyPeriod == 4
                  ? this.examplesData[5].bgc
                  : require("@/assets/leadCockpitImage/land.png");
              feature.setProperties({
                id: id,
                center: center,
                fillColor: fillColor,
              });
              let style = that.mapView.setPointStyle("", imgUrl, 1);
              return style;
            }
          );
        }
      });
    },
    setChunks() {
      let me = this;
      let data = me.mapView.getViewExtent(); //获取视图范围
      let scope = [
        [data[0], data[3]],
        [data[2], data[3]],
        [data[2], data[1]],
        [data[0], data[1]],
        [data[0], data[3]],
      ];
      let obj = {
        scope: {
          type: "MultiPolygon",
          coordinates: [[scope]],
        },
        supplyPeriod: this.form.supplyPeriod,
        minArea: this.form.areaMin,
        maxArea: this.form.areaMax,
        type: this.form.type,
        industryType: this.form.industryType,
        isReserve: this.form.isReserve,
      };
      getAllShpByScope(obj).then((res) => {
        let data = res.data.data;
        //预防数据还未请求成功，地图层级已变化到不需要画面的情况
        if (this.levels <= 12) {
          return false;
        }
        this.mapView.removeLayer("landLayerId"); //先清除再渲染
        let geojson = this.concert.toGeoJson(
          data,
          "geom",
          ["fromDataName", "id", "supplyPeriod", "lng", "lat", "fromDataId"],
          4490
        );
        this.mapView.addGeojsonMapLayer(
          geojson,
          "landLayerId",
          layerData[0].layerIndex,
          1,
          undefined,
          undefined,
          (feature) => {
            let properties = feature.getProperties();
            let id = "chunkId_" + properties.fromDataId;

            let fillColor =
              properties.supplyPeriod == 1
                ? this.examplesData[3].bgc1
                : properties.supplyPeriod == 3
                ? this.examplesData[4].bgc1
                : properties.supplyPeriod == 4
                ? this.examplesData[5].bgc1
                : ""; //填充色; //填充色

            let center = [properties.lng, properties.lat];
            feature.setProperties({
              id: id,
              center: center,
              fillColor: fillColor,
            });

            return this.mapView.setPolygonStyle(
              properties.fromDataName,
              "rgba(0,0,0,0)",
              fillColor,
              "#fff"
            );
          }
        );
      });
    },
    //移除表
    removeEcharts() {
      for (let i in this.echartObjs) {
        if (this.echartObjs[i]) {
          this.echartObjs[i].dispose();
        }
      }
      this.echartObjs = [];
      this.showEchart = false;
    },
    //移除点
    removeMarkers() {
      for (let i in this.markerIds) {
        this.mapView.removeVectorFeatureById(this.markerIds[i]);
      }
      this.markerIds = [];
      this.mapView.removeLayer("landPointLayerId"); //清除用地点图层
    },
    //移除面
    removeChunks() {
      for (let i in this.chunkIds) {
        this.mapView.removeVectorFeatureById(this.chunkIds[i]);
      }
      this.chunkIds = [];
      this.mapView.removeLayer("landActiveLayerId"); //移除选中地块面
      this.mapView.removeLayer("landLayerId"); //移除地块面
    },
    addEchart(data, index) {
      let text = "";
      if (this.form.supplyPeriod == 1) {
        text = `${data.city}\n${data.dataList[0]}`;
      }
      if (this.form.supplyPeriod == 3) {
        text = `${data.city}\n${data.dataList[1]}`;
      }
      if (this.form.supplyPeriod == 4) {
        text = `${data.city}\n${data.dataList[2]}`;
      }

      if (this.form.supplyPeriod == null) {
        text = `${data.city}\n${data.dataSum}`;
      }
      //更新前销毁之前的echart对象
      this.$echarts.init(document.getElementById("echart_" + index)).dispose();

      let option = {
        tooltip: {
          trigger: "item",
          formatter: (val) => {
            let str =
              val.marker +
              `<span>${val.seriesName}</span><br/><span>${val.name}:&nbsp;&nbsp;${val.data.value}宗</span>`;
            return str;
          },
        },
        title: {
          text: text,
          left: "center",
          top: "35%",
          textStyle: {
            textAlign: "center",
            fontSize: 12,
            color: "#000",
          },
        },
        series: [
          {
            name: data.city,
            type: "pie",
            zlevel: 3, //层级
            radius: ["40%", "60%"],
            avoidLabelOverlap: false,
            label: {
              show: false, // 鼠标移上去 圆环中间显示信息
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                name: "立等可供",
                value:
                  data.dataList[0] != 0 &&
                  (this.form.supplyPeriod == 1 ||
                    this.form.supplyPeriod == null)
                    ? data.dataList[0]
                    : "",
                itemStyle: {
                  color: "#02D64A",
                },
              },
              {
                name: "计划可供",
                value:
                  data.dataList[1] != 0 &&
                  (this.form.supplyPeriod == 3 ||
                    this.form.supplyPeriod == null)
                    ? data.dataList[1]
                    : "",
                itemStyle: {
                  color: "#497AFF",
                },
              },
              {
                name: "规划可用",
                value:
                  data.dataList[2] != 0 &&
                  (this.form.supplyPeriod == 4 ||
                    this.form.supplyPeriod == null)
                    ? data.dataList[2]
                    : "",
                itemStyle: {
                  color: "#FDBA32",
                },
              },

              {
                name: "暂无地块",
                value: 0,
                itemStyle: {
                  color: "#e0e0e0",
                },
              },
            ],
          },
          {
            type: "pie",
            zlevel: 0,
            silent: true,
            radius: ["0%", "40%"],
            color: "#fff",
            label: {
              show: true,
              position: "center",
              rich: {
                name: {
                  fontSize: 10,
                  color: "#FF0000",
                },
              },
            },
            data: [1],
          },
        ],
      };

      let dom = document.getElementById("echart_" + index);
      let chart = this.$echarts.init(dom);
      chart.setOption(option, false);
      this.echartObjs.push(chart);
      this.showEchart = true;
      addChartsOverlay(
        document.getElementById("echart_" + index),
        data.lnglatList,
        "center-center",
        "echart_" + data.value
      );
    },
    echartClick(item) {
      if (item.value) {
        let code = item.value;
        let len = code.length;
        this.xzqhName = item.city;
        let county = [];
        if (len == 6) {
          let str1 = code.substring(0, 2); //省
          let str2 = code.substring(0, 4); //市
          county.push(str1, str2, code);
        } else if (len == 4) {
          let str1 = code.substring(0, 2); //省
          county.push(str1, code);
        } else {
          county.push(data.county);
        }
        this.regionValue = county;
        if (this.regionValue.length > 1) {
          this.changeRegion(this.regionValue[1]);
        } else {
          this.changeRegion(this.regionValue);
        }
      }
    },
    getLandShp(id, name, imgUrl) {
      getShp(id).then((res) => {
        if (res.data.success) {
          let landShp = res.data.data;
          let center = this.mapView.getMultiPolygonCenter(
            landShp.shapeInfo[0].geom.coordinates
          );
          this.darwLand(center, name, id, imgUrl);
        }
      });
    },
    //当前页用地数据打点
    darwLand(center, name, id, imgUrl) {
      this.mapView.addVectorPoint(
        center,
        name,
        imgUrl ? imgUrl : require("@/assets/leadCockpitImage/land.png"),
        { id: "land_" + id },
        "#007eff",
        "#fff",
        0,
        [0.5, 0.5]
      );
    },

    //搜索默认值
    getParkSearchDefault() {
      searchDefault({ type: 0 }).then((res) => {
        if (res.data.success) {
          this.parkSearchList = res.data.data;
        }
      });
    },
    getLandSearchDefault() {
      searchDefault({ type: 1 }).then((res) => {
        if (res.data.success) {
          this.landSearchList = res.data.data;
        }
      });
    },
    closeInfluence() {
      this.influence = false;
    },
    landUse(index) {
      this.landUseIndex = index;
    },

    // 可供
    offerings1() {
      this.offeringsIndex1 = !this.offeringsIndex1;
      this.form.supplyPeriod = this.offeringsIndex1 ? 1 : null;
      this.searchFrom();
      if (this.offeringsIndex1) {
        this.offeringsIndex2 = false;
        this.offeringsIndex3 = false;
        this.offeringsIndex4 = false;
      }
    },
    offerings2() {
      this.offeringsIndex2 = !this.offeringsIndex2;
      this.form.supplyPeriod = this.offeringsIndex2 ? 4 : null;
      this.searchFrom();
      if (this.offeringsIndex2) {
        this.offeringsIndex1 = false;
        this.offeringsIndex3 = false;
        this.offeringsIndex4 = false;
      }
    },
    offerings3() {
      this.offeringsIndex3 = !this.offeringsIndex3;
      this.form.supplyPeriod = this.offeringsIndex3 ? 3 : null;
      this.searchFrom();
      if (this.offeringsIndex3) {
        this.offeringsIndex1 = false;
        this.offeringsIndex2 = false;
        this.offeringsIndex4 = false;
      }
    },
    offerings4() {
      this.offeringsIndex4 = !this.offeringsIndex4;
      this.form.supplyPeriod = this.offeringsIndex4 ? 4 : null;
      this.searchFrom();

      if (this.offeringsIndex4) {
        this.offeringsIndex1 = false;
        this.offeringsIndex2 = false;
        this.offeringsIndex3 = false;
      }
    },
    // 查询确定
    onSubmit() {},
    queryParkFormSearch(queryString, cb) {
      var restaurants = this.parkSearchList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleParkFormSelect(item) {},
    queryLandFormSearch(queryString, cb) {
      var restaurants = this.landSearchList;
      var results = queryString
        ? restaurants.filter(this.createLandFormFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleLandFormSelect(item) {},
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    createLandFormFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 工具栏
    unfoldTool() {
      this.show3 = !this.show3;
      if (this.show3) {
        this.unfold = "el-icon-s-unfold";
      } else {
        this.unfold = "el-icon-s-fold";
        // const available= document.querySelector(".available")
        // console.log(available);
        // available.style.transition = "all 5s linear";
      }
    },
    // 右侧缩放
    leftParkExpand() {
      this.isLandExpand = !this.isLandExpand;
      // 获取工具栏
      const tool = document.querySelector(".statistics-content");
      if (this.isLandExpand) {
        tool.style.left = "30px";
        tool.style.transition = "all 0.5s linear";
      } else {
        tool.style.top = "430px";
        tool.style.transition = "all 0.5s linear";
      }
      const tool1 = document.querySelector(".statistics-content-expend");
      if (this.isLandExpand) {
        tool1.style.left = "10px";
        tool1.style.transition = "all 0.5s linear";
      } else {
        tool1.style.left = "410px";
        tool1.style.transition = "all 0.5s linear";
      }
      // 获取地图自带影像
      const toggle = document.querySelector(".tz-toggle-layout");
      if (this.isLandExpand) {
        toggle.classList.add("new-toggle-layout");
        toggle.classList.remove("toggle-layout");
      } else {
        toggle.classList.add("toggle-layout");
        toggle.classList.remove("new-toggle-layout");
      }
    },
    // 缩放
    parkExpand() {
      this.isParkExpand = !this.isParkExpand;

      this.isProjectpand = true;
      // 获取工具栏
      const available = document.querySelector(".available");
      if (this.isParkExpand) {
        // available.style.right = "10px";
        // available.style.transition = "all 0.5s linear";
      } else {
        // available.style.right = "390px";
        // available.style.transition = "all 0.5s linear";
      }
      // 获取工具栏
      const tool = document.querySelector(".tool-box-center");
      if (this.isParkExpand) {
        tool.style.right = "10px";
        tool.style.transition = "all 1s linear";
      } else {
        tool.style.right = "10px";
        tool.style.transition = "all 1s linear";
      }
      // 获取图例
      const keyMap = document.querySelector(".map-tl");
      if (this.isParkExpand) {
        // keyMap.style.right = "10px";
        // keyMap.style.transition = "all 0.5s linear";
      } else {
        // keyMap.style.right = "390px";
        // keyMap.style.transition = "all 0.5s linear";
      }
      this.getParkTable();
    },

    //土地用途列表
    gettdlx() {
      getTypeList({ search: true }).then((res) => {
        if (res.data.success) {
          this.tdytList = res.data.data;
        }
      });
    },

    //初始化地图
    initMap() {
      this.mapView = this.$refs.tzMap.tzApi;
      var time1 = setTimeout(() => {
        clearTimeout(time1);
        let extent = [
          97.52911377278247, 21.144353867437076, 106.19421387087351,
          29.251119613779224,
        ];
        this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]); //居中地图范围
      }, 10);

      this.mapView.map.addInteraction(new DoubleClickZoom());
      systemConfig.mapApi = this.mapView;
      systemConfig.olApi = this.$refs.tzMap.olApi;

      this.mapView.addSingleClickCallBack((arg1, xy) => {
        console.log(xy, arg1);
        this.isLandExpand = true;
        if (!arg1) {
          return false;
        }
        let attribute = arg1.getProperties();
        //点击园区点
        if (attribute.id && attribute.id.indexOf("spot_") != -1) {
          this.mapView.removeLayer("parkActiveLayerId"); //移除选中园区图层
          getParkDetail(attribute.fromDataId).then((res) => {
            if (res.data.success) {
              this.rootPark = new parkDeatilInfo();
              let data = res.data.data;
              let routerData = this.$router;
              this.rootPark.showMapTip(attribute.center, data, routerData);
            }
          });
          this.getParkShpInfo(attribute.fromDataId);
        }
        //点击园区面
        if (attribute.id && attribute.id.indexOf("parkId_") != -1) {
          getParkDetail(attribute.parkId || attribute.fromDataId).then(
            (res) => {
              if (res.data.success) {
                this.rootPark = new parkDeatilInfo();
                let data = res.data.data;
                let routerData = this.$router;
                this.rootPark.showMapTip(
                  [attribute.lng, attribute.lat],
                  data,
                  routerData
                );
              }
            }
          );
          this.mapView.removeLayer("parkActiveLayerId"); //移除选中园区图层
          this.getParkShpInfo(attribute.parkId || attribute.fromDataId);
        }

        //判断是否面点击
        if (attribute.id && attribute.id.indexOf("marker_") != -1) {
          getLandInfoTwo(attribute.fromDataId).then((res) => {
            if (res.data.success) {
              let data = res.data.data;

              this.root = new landDetailInfo();
              let routerData = this.$router;
              this.root.showMapTip(attribute.center, data, routerData);

              this.form.name = attribute.fromDataName;
              //画面
              getShp(attribute.fromDataId).then((res) => {
                if (res.data.success) {
                  let landShp = res.data.data;
                  this.onLandLocation(
                    landShp.shapeInfo,
                    data,
                    attribute.fillColor
                  );
                }
              });
            }
          });
        }

        //判断缩放时展示的地块点击查看详情数据
        if (attribute.id && attribute.id.indexOf("chunkId_") != -1) {
          this.mapView.removeLayer("landActiveLayerId"); //移除选中地块面
          getLandInfoTwo(attribute.fromDataId).then((res) => {
            if (res.data.success) {
              let data = res.data.data;

              this.root = new landDetailInfo();
              let routerData = this.$router;
              this.root.showMapTip(arg1.values_.center, data, routerData);

              //画面
              getShp(attribute.fromDataId).then((res) => {
                if (res.data.success) {
                  let landShp = res.data.data;
                  this.onLandLocation(
                    landShp.shapeInfo,
                    data,
                    attribute.fillColor
                  );
                }
              });
            }
          });
        }
      });
    },
    getParkShpInfo(id, isCase) {
      getParkShp(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            [
              "fromDataName",
              "id",
              "parkLevel",
              "lng",
              "lat",
              "fromDataId",
              "parkCode",
            ],
            4490
          );
          this.$nextTick(() => {
            this.mapView.addGeojsonMapLayer(
              geojson,
              "parkActiveLayerId",
              layerData[1].layerIndex,
              1,
              undefined,
              undefined,
              (feature) => {
                let properties = feature.getProperties();

                let id = "parkId_" + properties.fromDataId;
                let center = [properties.lng, properties.lat];
                feature.setProperties({ id: id, center: center });
                let fillColor = "";
                if (properties.parkCode != "DZXQ") {
                  let index = Number(properties.parkLevel);
                  fillColor = this.parkImgList[index].bgc1;
                } else {
                  fillColor = this.parkImgList[0].bgc1;
                }

                return this.mapView.setPolygonStyle(
                  properties.fromDataName,
                  "#28d7ff",
                  fillColor,
                  "#fff"
                );
              }
            );
            this.$nextTick(() => {
              this.mapView.zoomToExtentByLayerId("parkActiveLayerId");
            });
            if (isCase) {
              this.getParkdetial(id, [data[0].lng, data[0].lat]); //获取园区详情
            }
          });
        }
      });
    },

    //定位到详情 1：园区   2：地块
    goUrl: function (val) {
      if (val == 2) {
        this.$router.push({ path: "/land/list" });
        window.sessionStorage.setItem("activeNavLabel", "土地仓库");
        window.sessionStorage.setItem(
          "breadcrumbNavDataStore",
          '[{"name":"土地仓库","path":"/land/list","query":{}}]'
        );
        this.$router.push({
          path: "/land/detail",
          query: { id: this.listData.id },
        });
      } else {
        //this.$router.push({ path: "/land/list" });
        window.sessionStorage.setItem("activeNavLabel", "土地仓库");
        window.sessionStorage.setItem(
          "breadcrumbNavDataStore",
          '[{"name":"园区（开发区）","path":"/land/park","query":{}}]'
        );
        this.$router.push({
          path: "/parkDetail",
          query: { id: this.parkIdActive },
        });
      }

      //
    },
    findData(list, filed) {
      let index = list.findIndex((item) => item.filed == filed);
      let value = index >= 0 ? list[index].value : "";
      return value;
    },
    //图层已勾选数据
    callBackCheckNode(list) {
      this.checkNodeData = list;
    },

    clearFrom() {
      this.searchValue = "";
      this.landList = [];
      //this.parkList = [];
    },
    searchFrom() {
      this.where = "";
      this.form.current = 1;
      // this.isShowlandBox = false;
      // this.isLandExpand = false;
      // if (this.form.label) {
      //   if (this.form.label.length > 1) {
      //     this.form.label = this.form.label.slice(-1)[0].toString();
      //   } else {
      //     this.form.label = this.form.label.toString();
      //   }
      // }
      //  else if(this.form.label.length>0&&this.form.label) {
      //   // this.form.label = this.form.label.toString()
      // }
      this.getLands();
    },

    //获取行政区划
    getXzqh() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },

    //根据行政区划
    changeRegion(val) {
      getCountyShp({ county: val }).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          // this.mapView.removeLayer("countyLayer"); //清除选中行政区划图层
          let extent = this.mapView.getMultiPolygonExtent(
            data.geom.coordinates
          );
          this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]); //居中地图范围
          // if (val == "53") {

          //   return false;
          // }
          return;
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["countyName", "county", "lng", "lat"],
            4490
          );
          this.mapView.addGeojsonMapLayer(
            geojson,
            "countyLayer",
            101,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              return this.mapView.setPolygonStyle(
                "",
                "#1d9300",
                "rgba(0,0,0,0)",
                "rgba(0,0,0,0)",
                "rgba(0,0,0,0)",
                undefined,
                undefined,
                5
              );
            }
          );
          this.mapView.zoomToExtentByLayerId("countyLayer");
        }
      });
    },

    //切换页码
    handleCurrentChange(val) {
      this.form.current = val;
      this.getLands();
    },

    //切换页条数
    handleSizeChange(val) {
      this.form.size = val;
      this.getLands();
    },

    //切换园区页码
    handleParkCurrentChange(val) {
      this.parkForm.current = val;
      this.getParkTable();
    },
    //切换园区页条数
    handleParkSizeChange() {
      this.parkForm.size = val;
      this.getParkTable();
    },
    // 切换项目招商页面
    handleProjectCurrentChange(val) {
      this.projectForm.current = val;
      this.getprojectLsist();
    },
    // 切换项目招商页条数
    handleProjectSizeChange() {
      this.projectForm.size = val;
      this.getprojectLsist();
    },
    //
    /**
     * val 有值为条件查询
     */
    getParkTable() {
      this.parkLoading = true;
      let params = Object.assign(this.parkForm, {
        county: this.countyValue,
      });
      getParkPage(params).then((res) => {
        if (res.data.success) {
          this.parkForm.total = res.data.data.total;
          let list = res.data.data.records;
          //清除用地图斑
          if (this.landMap.length && !this.isSkip) {
            this.landMap.forEach((item) => {
              this.mapView.removeVectorFeatureById(item);
            });
          }
          this.isSkip = false;
          this.landMap = [];
          this.fristPark = false;
          if (!list.length) {
            this.isParkBtottom = true;
          }
          list.forEach((item) => {
            this.$set(item, "isAtive", false);
            if (item.pronounceImages) {
              let imgUrl =
                item.pronounceImages.length > 0
                  ? systemConfig.imgServer +
                    systemConfig.imgApi +
                    item.pronounceImages[0].filePath
                  : null;
              this.$set(item, "imgUrl", imgUrl);
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
            if (item.pronounceImages && item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
          });
          this.parkList = list;

          this.parkLoading = false;
        }
      });
    },

    async getLands() {
      this.landLoading = true;
      this.$refs.popoverRef.doClose();
      this.removeEcharts();
      this.getSupplyPeriodList();
      let params = Object.assign(this.form, {
        county: this.countyValue,
      });
      if (!!this.where) {
        params.parkCode = this.where;
      } else {
        params.parkCode = "";
      }
      let { data: res } = await landList(params);
      if (res.success) {
        let list = res.data.records;
        this.form.total = res.data.total;
        //清除园区图斑
        if (!this.isSkip1) {
          this.mapView.removeVectorFeatureById("kfq_layer");
        }
        this.isSkip1 = false;
        list.forEach((item) => {
          this.$set(item, "isAtive", false);
          if (item.pronounceImages) {
            let imgUrl =
              item.pronounceImages.length > 0
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  item.pronounceImages[0].filePath
                : null;
            this.$set(item, "imgUrl", imgUrl);
            item.pronounceImages = item.pronounceImages
              ? item.pronounceImages
              : [];
            if (item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
            if (item.pronounceApproval && item.pronounceApproval.length) {
              item.pronounceApproval.forEach((itemFile) => {
                if (itemFile.suffix == "mp4") {
                  this.$set(
                    itemFile,
                    "thumbnailSrc",
                    systemConfig.imgServer +
                      systemConfig.imgApi +
                      itemFile.thumbnail
                  );
                }
                if (
                  itemFile.suffix == "png" ||
                  itemFile.suffix == "jpg" ||
                  itemFile.suffix == "pdf" ||
                  itemFile.suffix == "docx" ||
                  itemFile.suffix == "doc" ||
                  itemFile.suffix == "xlsx" ||
                  itemFile.suffix == "xls"
                ) {
                  this.$set(
                    itemFile,
                    "url",
                    systemConfig.imgServer +
                      systemConfig.imgApi +
                      itemFile.filePath
                  );
                }
              });
            }
          }
        });

        this.landList = list;
        // console.log(this.landList);
        // if(this.from.total>0){
        //   // this.isLandExpand=false
        // }else{
        //   // this.isLandExpand=true
        // }
        this.landLoading = false;
        // if(this.form.areaMax&&this.form.areaMin){
        //    this.offerArea=true
        // }else{
        //   this.offerArea=false
        // }
      }
    },

    //查询用地详情
    getLandDetail(id) {
      let detailInfo = {};
      this.mapView.removeLayer("landActiveLayerId"); //移除选中地块面
      //查询详情
      getLandInfoTwo(id).then((res) => {
        if (res.data.success) {
          let landInfo = res.data.data;
          //查询图形数据
          let loading = this.$loading({
            text: "正在获取图形数据...",
            target: document.getElementById("mapView"),
          });

          getShp(id)
            .then((res) => {
              if (res.data.success) {
                let landShp = res.data.data;
                let fillColor =
                  landInfo.supplyPeriod == 1
                    ? this.examplesData[3].bgc1
                    : landInfo.supplyPeriod == 3
                    ? this.examplesData[4].bgc1
                      ? landInfo.supplyPeriod == 4
                      : this.examplesData[5].bgc1
                    : ""; //填充色
                this.onLandLocation(landShp.shapeInfo, landInfo, fillColor);

                let center = [
                  landShp.shapeInfo[0].lng,
                  landShp.shapeInfo[0].lat,
                ];
                this.root = new landDetailInfo();
                let routerData = this.$router;
                this.root.showMapTip(center, landInfo, routerData);
              }
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    },
    //用地定位
    onLandLocation(arr, data, fillColor) {
      let geojson = this.concert.toGeoJson(
        arr,
        "geom",
        ["fromDataName", "id", "supplyPeriod", "lng", "lat", "fromDataId"],
        4490
      );

      this.mapView.addGeojsonMapLayer(
        geojson,
        "landActiveLayerId",
        layerData[0].layerIndex,
        1,
        undefined,
        undefined,
        (feature) => {
          let properties = feature.getProperties();
          let id = "chunkId_" + properties.fromDataId;
          let center = [properties.lng, properties.lat];
          feature.setProperties({ id: id, center: center });
          let fillColor =
            properties.supplyPeriod == 1
              ? this.examplesData[3].bgc1
              : properties.supplyPeriod == 3
              ? this.examplesData[4].bgc1
              : properties.supplyPeriod == 4
              ? this.examplesData[5].bgc1
              : ""; //填充色

          return this.mapView.setPolygonStyle(
            properties.fromDataName,
            "#28d7ff",
            fillColor,
            "#fff",
            undefined,
            undefined,
            undefined,
            2
          );
        }
      );
      this.mapView.zoomToExtentByLayerId("landActiveLayerId");
    },

    //查询园区 园区定位
    parkData(parkCodeActual, info) {
      this.mapView.queryArcGISRestByAttribute(
        layerConfig.parkUrl,
        2,
        `CYYDM = '${parkCodeActual}'`,
        (res) => {
          if (res.features && res.features.length) {
            let { geometry, attributes } = res.features[0];
            if (geometry) {
              let zb = geometry.rings;
              //居中地图范围
              let extent = this.mapView.getPolygonExtent(zb);
              this.mapView.zoomToExtent(
                extent[0],
                extent[1],
                extent[2],
                extent[3]
              );
              this.mapView.addVectorMultiPolygon(
                [geometry.rings],
                attributes.CYYMC,
                { id: "kfq_layer", layerData: info },
                "#04ebf0",
                "rgba(0,0,0,0)",
                "#ffffff",
                "#04ebf0",
                undefined,
                undefined,
                4
              );
              this.parkPopup(attributes, info, zb);
            }
          }
        }
      );
    },
    //园区详情弹窗
    parkPopup(attributes, info, zb) {
      this.rootPark = new parkDeatilInfo();
      let routerData = this.$router;
      let popupCenter = this.mapView.getCenterOfPolygon(zb);
      this.rootPark.showMapTip(popupCenter, info, routerData);
    },

    // 项目招商定位
    projectLocation(arr, data) {
      let geojson = this.concert.toGeoJson(
        arr,
        "geom",
        ["geom", "lng", "lat"],
        4490
      );

      this.mapView.addGeojsonMapLayer(
        geojson,
        "projectLayer",
        104,
        1,
        undefined,
        undefined,
        (feature) => {
          let properties = feature.getProperties();
          return this.mapView.setPolygonStyle(
            "",
            "#dafffe",
            "rgb(255,255,255,0.2)",
            "#dafffe",
            undefined,
            [10, 10, 10],
            undefined,
            4
          );
        }
      );
      this.mapView.zoomToExtentByLayerId("projectLayer");
    },

    //园区详情
    getParkdetial(id, center) {
      getParkDetail(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          this.rootPark = new parkDeatilInfo();
          let routerData = this.$router;
          this.rootPark.showMapTip(center, data, routerData);
          // this.parkData(data.parkCodeActual, data); //查询园区 地图范围
        }
      });
    },
    /**
     * info:园区信息 ， val:是否选中 ,nowIndex:当前操作下标
     */
    async detailBtnPark(info, val, nowIndex) {
      let data = {
        parkCode: info.parkCode,
      };
      getChunkCenterList(data);
      // this.countyValue=info.parkCode
      //关联地块查询 若没有选中时清空联查
      this.where = val ? info.parkCode : "";
      await this.getLands();
      this.detailParkInfo = info;
      //关闭弹窗
      this.landShow = false;
      if (val) {
        this.mapView.removeLayer("parkActiveLayerId"); //移除选中园区图层
        this.getParkShpInfo(info.id);
      }
      this.parkList.forEach((item, index) => {
        if (index == nowIndex) {
          item.isAtive = val;
        } else {
          item.isAtive = false;
        }
      });
    },
    async detailBtnProjcet(info, val, nowIndex) {
      this.projectList.forEach((item, index) => {
        if (index == nowIndex) {
          item.isAtive = !item.isAtive;
        } else {
          item.isAtive = false;
        }
      });
      this.mapView.removeLayer("projectLayer"); //清除项目图层
      cleanChartsOverlayId("projectSpot"); //清除项目点
      if (!this.projectList[nowIndex].isAtive) {
        return false;
      }
      this.projectInfo = info;
      if (!info.classify) {
        this.drawProjectRange(info);
      }
      //以地招商
      if (info.classify == 1) {
        var codes = [];

        let loading = this.$loading({
          text: "正在获取图形数据...",
          target: document.getElementById("mapView"),
        });
        await projectIDLIST(info.id).then((res) => {
          loading.close();
          if (res.data.success) {
            res.data.data.map((item) => {
              codes.push(item.shpFile.shapeInfo[0]);
            });
          } else {
            // this.$message.error(res.data.msg);
          }
        });
        if (!codes.length) {
          this.drawProjectRange(info);
          return;
        }
        let geojson = this.concert.toGeoJson(
          codes,
          "geom",
          ["geom", "lng", "lat", "fromDataName"],
          4490
        );
        this.mapView.addGeojsonMapLayer(
          geojson,
          "projectLayer",
          104,
          1,
          undefined,
          undefined,
          (feature) => {
            let properties = feature.getProperties();
            return this.mapView.setPolygonStyle(
              "",
              "#dafffe",
              "rgb(255,255,255,0.2)",
              "#dafffe",
              undefined,
              [10, 10, 10],
              undefined,
              4
            );
          }
        );
        this.mapView.zoomToExtentByLayerId("projectLayer");
      }
      //以商找地
      if (info.classify == 0) {
        if (info.geomConfirm) {
          //画面
          if (info.rangeType == 1) {
            let geom = info.geom;
            geom.coordinates = JSON.parse(geom.coordinates);
            this.drawProject([{ geom: geom }]);
          }
          //画shp
          if (info.rangeType == 3) {
            let loading = this.$loading({
              text: "正在获取图形数据...",
              target: document.getElementById("mapView"),
            });
            getProjectShp(info.id).then((res) => {
              loading.close();
              if (res.data.success) {
                this.projectShp = res.data.data;
              }
            });
          }
          if (info.rangeType == 2) {
            this.drawProjectSpot([info.lng, info.lat], info.projectName);
            this.mapView.flyTo([info.lng, info.lat], 14);
          }
        } else {
          this.drawProjectRange(info);
        }
      }
      // if (val) {
      //   this.getprojectDetail(info.id);
      // }
    },

    // 招商项目定位详情
    async handleDetailsLocation(info, val, nowIndex) {
      this.mapView.removeLayer("projectLayer"); //清除项目图层
      cleanChartsOverlayId("projectSpot"); //清除项目点
      this.projectInfo = info;
      if (!info.classify) {
        this.drawProjectRange(info);
      }
      //以地招商
      if (info.classify == 1) {
        var codes = [];
        let loading = this.$loading({
          text: "正在获取图形数据...",
          target: document.getElementById("mapView"),
        });
        await projectIDLIST(info.id).then((res) => {
          loading.close();
          if (res.data.success) {
            res.data.data.map((item) => {
              codes.push(item.shpFile.shapeInfo[0]);
            });
          } else {
            // this.$message.error(res.data.msg);
          }
        });
        if (!codes.length) {
          this.drawProjectRange(info);
          return;
        }
        let geojson = this.concert.toGeoJson(
          codes,
          "geom",
          ["geom", "lng", "lat", "fromDataName"],
          4490
        );
        this.mapView.addGeojsonMapLayer(
          geojson,
          "projectLayer",
          104,
          1,
          undefined,
          undefined,
          (feature) => {
            let properties = feature.getProperties();
            return this.mapView.setPolygonStyle(
              "",
              "#dafffe",
              "rgb(255,255,255,0.2)",
              "#dafffe",
              undefined,
              [10, 10, 10],
              undefined,
              4
            );
          }
        );
        this.mapView.zoomToExtentByLayerId("projectLayer");
      }
      //以商找地
      if (info.classify == 0) {
        if (info.geomConfirm) {
          //画面
          if (info.rangeType == 1) {
            let geom = info.geom;
            geom.coordinates = JSON.parse(geom.coordinates);
            this.drawProject([{ geom: geom }]);
          }
          //画shp
          if (info.rangeType == 3) {
            let loading = this.$loading({
              text: "正在获取图形数据...",
              target: document.getElementById("mapView"),
            });
            getProjectShp(info.id).then((res) => {
              loading.close();
              if (res.data.success) {
                this.projectShp = res.data.data;
              }
            });
          }
          if (info.rangeType == 2) {
            setTimeout(() => {
              this.drawProjectSpot([info.lng, info.lat], info.projectName);
              this.mapView.flyTo([info.lng, info.lat], 14);
            }, 100);
          }
        } else {
          this.drawProjectRange(info);
        }
      }
    },
    drawProjectRange(info) {
      if (info.parkCode) {
        getParkCodeShp(info.parkCode).then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            let geojson = this.concert.toGeoJson(
              data,
              "geom",
              ["fromDataName", "lng", "lat"],
              4490
            );
            this.mapView.addGeojsonMapLayer(
              geojson,
              "projectLayer",
              104,
              1,
              undefined,
              undefined,
              (feature) => {
                return this.mapView.setPolygonStyle(
                  "",
                  "#dafffe",
                  "rgb(255,255,255,0.2)",
                  "#dafffe",
                  undefined,
                  [10, 10, 10],
                  undefined,
                  4
                );
              }
            );
            this.mapView.zoomToExtentByLayerId("projectLayer");
          }
        });
        return false;
      }
      if (info.county) {
        getCountyShp({ county: info.county }).then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            let geojson = this.concert.toGeoJson(
              data,
              "geom",
              ["countyName", "lng", "lat"],
              4490
            );
            this.mapView.addGeojsonMapLayer(
              geojson,
              "projectLayer",
              104,
              1,
              undefined,
              undefined,
              (feature) => {
                return this.mapView.setPolygonStyle(
                  "",
                  "#dafffe",
                  "rgb(255,255,255,0.2)",
                  "#dafffe",
                  undefined,
                  [10, 10, 10],
                  undefined,
                  4
                );
              }
            );
            this.mapView.zoomToExtentByLayerId("projectLayer");
          }
        });
        return false;
      }
      this.$message.error("暂无项目范围");
    },
    //画项目点
    drawProjectSpot(coordinate, name) {
      this.rootProject = new projectInfo();
      this.rootProject.showMapTip(coordinate, name);
      // this.mapView.addVectorPoint(
      //   coordinate,
      //   name,
      //   require("@/assets/leadCockpitImage/project.png"),
      //   { id: "projectSpot" },
      //   "#000",
      //   "#fff",
      //   10,
      //   [0.5, 27],
      //   undefined,
      //   "50px"
      // );
    },
    //画项目图形
    drawProject(data) {
      let geojson = this.concert.toGeoJson(data, "geom");
      let that = this;
      this.mapView.addGeojsonMapLayer(
        geojson,
        "projectLayer",
        104,
        1,
        undefined,
        undefined,
        (feature) => {
          return that.mapView.setPolygonStyle(
            "",
            "#dafffe",
            "rgb(255,255,255,0.2)",
            "#dafffe",
            undefined,
            [10, 10, 10],
            undefined,
            4
          );
        }
      );
      that.mapView.zoomToExtentByLayerId("projectLayer");
    },
    /**
     * info:地块信息 ， val:是否选中,nowIndex:当前操作下标
     */
    detailBtnLand(info, val, nowIndex) {
      if (val) {
        this.getLandDetail(info.id);
      }
      this.landList.forEach((item, index) => {
        if (index == nowIndex) {
          item.isAtive = val;
        } else {
          item.isAtive = false;
        }
      });
    },

    //提交需求
    releaseNeed() {
      // this.isReleaseNeed = !this.isReleaseNeed;
      this.$router.push("/land/releaseNeed");
    },

    //关闭需求
    closeNeed() {
      this.isReleaseNeed = false;
    },
    handleCurrentClick(item) {
      console.log(item);
    },

    resetLandQuery() {
      if (this.form.type != undefined) {
        this.form.areaMin = null;
        this.form.areaMax = null;
        this.form.type = "";
        this.form.name = "";
        this.getLands();
      }
    },
    // 快捷查询 地块  园区
    shortcutQuery(val) {
      if (this.typeStatus == val) {
        //相同则取消选择
        this.typeStatus = "";
      } else {
        this.typeStatus = val;
      }
      this.getLands();
    },
    // 地块搜索清空事件
    searchClear() {
      this.isLandExpand = true;
    },

    // 行政区划树形图
    handleNodeClick(data) {
      this.where = "";
      this.mapView.removeLayer("parkActiveLayerId"); //移除选中园区图层
      if (data == null) {
        this.xzqhName = "";
        this.countyValue = "";
        this.form.county = "";
        this.DKIsActivate = false;
        this.isLandExpand = true;
        this.projectForm.county = "";
        this.projectForm.current = 1;
        this.getprojectLsist();
        return false;
      } else {
        this.xzqhName = data.label;
        this.countyValue = data.value;
        this.form.county = data.value;
        this.changeRegion(data.value);
        this.projectForm.county = data.value;
        this.projectForm.current = 1;
        this.getprojectLsist();
      }

      this.getLands();
    },
    // 获取项目招商列表
    getprojectLsist() {
      this.projectLoading = true;
      projectList(this.projectForm).then((res) => {
        this.projectLoading = false;
        if (res.data.success) {
          let data = res.data.data.records;
          data.forEach((item) => {
            this.$set(item, "isAtive", false);
          });
          this.projectList = data;
          this.projectForm.total = res.data.data.total;
        }
      });
    },
    // 页面监听键盘回车
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.getLands();
        this.DKIsActivate = true;
        this.offerArea = false;
        if (this.form.areaMin && this.form.areaMax) {
          return;
        } else {
          this.form.areaMin = null;
          this.form.areaMax = null;
          this.isLandExpand = false;
        }
        // this.form.areaMin = null;
        // this.form.areaMax = null;
        // this.isLandExpand = false
      }
    },
    // 单击国家级开发区、省级开发区、其他开发区事件
    async handleonClickRegion(code) {
      let color = null;
      if (code == 1) {
        color = "rgb(166, 50, 255)";
      } else if (code == 2) {
        color = "rgb(0, 91, 231)";
      } else {
        color = "rab(63, 210, 108)";
      }
      let parkList = [];
      let codes = [];
      await getLevePark(code).then((res) => {
        if (res.data.success) {
          parkList = res.data.data;
          codes = parkList.map((res) => `'${res.code}'`);
        }
      });

      this.mapView.removeVectorFeatureById("dj_layer");
      let loading = this.$loading({
        text: "正在获取图形数据...",
        target: document.getElementById("mapView"),
      });
      this.mapView.queryArcGISRestByAttribute(
        layerConfig.parkUrl,
        2,
        `CYYDM in (${codes.join(",")})`,
        (res) => {
          let layerId = "dj_layer",
            minZoom = 8;
          loading.close();
          this.mapView.addEsrijsonMapLayer(
            res,
            layerId,
            2,
            1,
            minZoom - 1,
            20,
            () => {
              return this.mapView.setPolygonStyle(
                "",
                color,
                "rgba(0,0,0,0)",
                "#ffffff",
                "#04ebf0",
                undefined,
                undefined,
                4
              );
            }
          );
          this.mapView.zoomToExtentByLayerId(layerId);
          this.mapView.setZoomLevel(minZoom);
          //   if (res.features && res.features.length) {
          //   let { geometry, attributes } = res.features[0];
          //   if (geometry) {
          //     let zb = geometry.rings;
          //     //居中地图范围
          //     let extent = this.mapView.getPolygonExtent(zb);
          //     this.mapView.zoomToExtent(
          //       extent[0],
          //       extent[1],
          //       extent[2],
          //       extent[3]
          //     );
          //     this.mapView.addVectorMultiPolygon(
          //       [geometry.rings],
          //       attributes.CYYMC,
          //       { id: "dj_layer",  },
          //       color,
          //       "rgba(0,0,0,0)",
          //       "#ffffff",
          //       "#04ebf0",
          //       undefined,
          //       undefined,
          //       4
          //     );
          //   }
          // }
        }
      );
    },
    // 鼠标移动
    start(event) {
      this.isPressing = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
    },
    move(event) {
      if (this.isPressing) {
        // this.endX = event.clientX;
        // this.endY = event.clientY;
        this.isLandExpand = true;
        // console.log(`移动距离：${this.endX - this.startX}, ${this.endY - this.startY}`);
        // this.message = `移动距离：${this.endX - this.startX}, ${this.endY - this.startY}`;
      }
    },
    end() {
      this.isPressing = false;
    },
    // 图例隐藏
    handleCaretRight(bool) {
      let tl = document.querySelector(".map-tl");
      let tzToggleLayout = document.querySelector(".tz-toggle-layout");
      let rightIcon = document.querySelector(".rightIcon");
      this.rightIcon = !bool;

      if (bool) {
        tl.style.right = "-150px";
        tl.style.transition = "all 1s linear";
        tzToggleLayout.style.right = "-100px";
        tzToggleLayout.style.transition = "all 1s linear";
        rightIcon.style.right = "-10px";
        rightIcon.style.transition = "all 1s linear";
      } else {
        tl.style.right = "30px";
        tl.style.transition = "all 1s linear";
        tzToggleLayout.style.right = "30px";
        tzToggleLayout.style.transition = "all 1s linear";
        rightIcon.style.right = "138px";
        rightIcon.style.transition = "all 1s linear";
      }
      // let tl = document.querySelector(".map-tl")
      // let tzToggleLayout=document.querySelector(".tz-toggle-layout")
      // tl.style.right = "-200px";
      // tl.style.transition = "all 0.5s linear";
      // tzToggleLayout.style.right = "-100px";
      // tzToggleLayout.style.transition = "all 0.5s linear";
    },
    // // 图例图标移入事件
    handleRightIconEnter() {
      let imgleft = document.querySelector(".imgleft");
      imgleft.style.opacity = "1";
      imgleft.style.transition = "all 0.1s linear";
    },
    // // 图例图标移除事件
    handleRightIconleave() {
      let imgleft = document.querySelector(".imgleft");
      imgleft.style.opacity = "0";
      imgleft.style.transition = "all 2s linear";
    },
  },
  updated() {
    this.$nextTick(() => {
      let app = document.getElementById("app");
      const initializeWidth = window.innerWidth; //初始化网页宽度
      if (initializeWidth < 1800) {
        app.scrollTop = document.body.scrollHeight - 160;
      } else {
        app.scrollTop = document.body.scrollHeight - 150;
      }
    });
  },
  destroyed() {
    this.$nextTick(() => {
      let app = document.getElementById("app");
      app.scrollTop = 0;
    });
  },
};
</script>

<style scoped>
#need-land {
  display: flex;
  flex-direction: column;
  width: 100%;
  /*height: 900px;*/
  position: relative;
  background: #ededed;
}

::v-deep .popup-box {
  line-height: 26px;
  /*max-width: 500px;*/
}

::v-deep .popup-box-content {
  padding: 0 10px;
  max-height: 300px;
  overflow: auto;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  /*flex-wrap: wrap;*/
}

::v-deep .popup-span {
  /*width: 50%;*/
  /*text-align: left;*/
}

::v-deep .popup-box-btn {
  margin: 10px auto;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background: #157cf3;
  color: #fff;
  border-radius: 4px;
  text-align: center;
}

::v-deep .popup-box-title {
  color: #fff;
  font-size: 0.85rem;
  padding: 5px 10px;
  font-weight: bold;
  background: #0657b4;
}

::v-deep .ol-popup.hasclosebox .ol-popup-content {
  margin-right: 0;
  /*width: 340px;*/
}

::v-deep .ol-popup .ol-popup-content {
  padding: 0;
}

::v-deep .ol-popup .closeBox {
  position: absolute;
  margin: 0;
  right: 3px;
  top: 8px;
}

.administrative-region {
  /* position: absolute; */
  top: 20px;
  /*margin-left: 20px;*/
}

.layer {
  /* position: absolute; */
  top: 20px;
  height: 32px;
  /* margin-left: 20px; */
}

.tool {
  /* position: absolute; */
  top: 20px;
  margin-left: 10px;
}

.map-tl-container {
  width: 200px;
  height: 250px;
  z-index: 999;
  position: absolute;
  bottom: 10%;
  right: 0px;
}

.map-tl {
  position: absolute;
  bottom: 15%;
  /*right: 100px; *!*/
  /*top: 20px;*/
  right: 30px;
  background: #fff;
  box-shadow: 0 0 10px #d3d2d2;
  padding-bottom: 10px;
  border: 1px solid #6ab8fe;
  border-radius: 4px;
  z-index: 999;
}

.rightIcon {
  position: absolute;
  bottom: 30%;
  right: 138px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  /* background: red; */
  width: 40px;
  /* height: 80px; */
  /* background-image: url("../../assets/images/left-box.png"); */
  background-size: 100%, 100%;
  background-repeat: no-repeat;
  /* background: #fff; */
}

.imgleft {
  opacity: 0;
  /* display: none; */
}

.map-tl-title {
  text-align: center;
  padding: 5px 0;
  font-size: 0.85rem;
}

.map-tl-li {
  display: flex;
  font-size: 0.75rem;
  padding: 3px 10px;
}

.map-tl-li-span {
  padding-left: 5px;
  color: #787676;
}

.need-dialog {
  position: absolute;
  top: 60px;
  right: 20px;
}

.tool-box-center {
  position: absolute;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /*width: calc(100% - 800px);*/
  right: 10px;
  top: 20px;
  width: max-content;
  /* width: 48%; */
  justify-content: right;
  /* background: red; */
}

.tool-toolbar {
  display: flex;
  align-items: center;
}

.tz-toggle-layout {
  height: 85px !important;
  right: 40px;
  margin: 0 !important;
  top: auto !important;
  left: auto !important;
  bottom: 2% !important;
}

.new-toggle-layout {
  left: 0px !important;
  transition: all 0.5s linear !important;
}

.toggle-layout {
  left: 410px !important;
  transition: all 0.5s linear !important;
}

.top-toggle-layout {
  bottom: 1px !important;
  transition: all 0.5s linear !important;
}

.bottom-toggle-layout {
  top: calc(100% - 205px) !important;
  transition: all 0.5s linear !important;
}

/* /deep/ .tz-toggle-layout__warp_box {
  height: 85px !important;
  margin: 0 !important;
}
.tz-toggle-layout__warp {
  height: 85px !important;
  margin: 0 !important;
} */
.land-need-box {
  /* position: absolute; */
  top: 20px;
  margin-left: 10px;
  background: #fff;
  border: 1px solid #dcdfe6;
  line-height: 26px;
  border-radius: 4px;
  height: 26px;
  padding: 0 10px;
  width: 150px;
  font-size: 0.8rem;
}

.icon-unfold {
  background: #fff;
  /*margin-left: 10px;*/
  font-size: 1rem;
  cursor: pointer;
  color: #969696;
  height: 32px;
  line-height: 32px;
  padding: 0 5px;
  /* position: absolute; */
  /* right: 10px; */
  /* top: 0px; */
  margin-left: 10px;
  /*border-top-right-radius: 4px;*/
  /*border-bottom-right-radius: 4px;*/
}

.land-need-box-span1 {
  color: #787676;
}

.land-need-box-span2 {
  color: #0657b4;
  cursor: pointer;
}

.detail-box {
  position: absolute;
  z-index: 30;
  width: 26%;
  left: calc(26% + 164px);
  top: 80px;
  bottom: 10px;
}

.search-box1 {
  width: 395px;
  position: absolute;
  top: 56px;
  left: 11px;
  box-shadow: 0px 3px 4px 0px #cdcdcd;
}

.land-active {
  transition: all 0.5s linear;
  transform: translateX(0);
}

.land-leave {
  transition: all 0.5s linear;
  transform: translateX(-405px);
}

.land-leave1 {
  transition: all 0.5s linear;
  display: none;
}

.land-active1 {
  transition: all 0.5s linear;
  display: block;
}

.park-leave {
  display: none;
  /* opacity: 0; */
  transition: all 0.5s linear;
}

.park-active {
  transition: all 0.5s linear;
  display: block;
  /* opacity: 1; */
}

.project-box {
  width: 364px;
  position: absolute;
  right: 100px;
  top: 70px;
  background: #fff;
  box-shadow: 0px 3px 4px 0px #cdcdcd;
}

.project-active {
  transition: all 0.5s linear;
  display: block;
  /* opacity: 1; */
}

.project-leave {
  /* opacity: 0; */
  display: none;
  transition: all 0.5s linear;
}

.left-icon {
  position: absolute;
  top: calc(50% - 50px);
  right: -20px;
  border-radius: 0 8px 8px 0;
}

.left-icon-box {
  transition: transform 0.6s;
  transform: rotate(180deg);
}

.right-icon-box {
  transition: transform 0.6s;
  transform: rotate(0deg);
}

.icon-box {
  height: 50px;
  line-height: 50px;
  width: 20px;
  background: #2875e9;
  color: #fff;
  text-align: center;
  font-size: 1rem;

  cursor: pointer;
}

.right-icon {
  position: absolute;
  top: calc(50% - 50px);
  left: -20px;
  border-radius: 8px 0 0 8px;
}

.land-list {
  background: #fff;
  height: 608px;
  /* min-height: 160px; */
  overflow: auto;
  /*padding-top: 10px;*/
}

.search-box-input {
  width: 100%;
  height: 28px;
}

.search-box-box {
  background: #fff;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.search-box-box-top {
  margin-top: 43px;
  width: 160px;
  height: 100px;
}

.search-box-box-top > img {
  width: 100%;
  height: 100%;
}

.search-box-box-center {
  font-size: 0.75rem;
  color: #787676;
}

.search-box-box-btn {
  /* margin-top: 20px; */
  width: 100px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 0.85rem;
  color: #fff;
  background: #2875e9;
  border-radius: 6px;
  cursor: pointer;
}

.search-box-list {
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  margin-top: 20px;
}

.search-box-list-top {
  background: #fff;
  display: flex;
  height: 32px;
  line-height: 32px;
  border-radius: 8px 8px 0 0;
}

.search-box-list-top-li {
  width: 50%;
  text-align: center;
  font-size: 0.85rem;
}

.active-li {
  color: #fff;
  background: #157cf3;
}

.dft-li {
  color: #787676;
  border: 1px solid #157cf3;
}

.search-box-list-table {
  background: #fff;
  height: calc(100% - 78px);
  min-height: 439px;
  overflow: auto;
  width: calc(100% - 2px);
  border-left: 1px solid #b1abab;
  border-right: 1px solid #b1abab;
}

.search-box-list-page {
  background: #fff;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border-left: 1px solid #b1abab;
  border-right: 1px solid #b1abab;
  border-bottom: 1px solid #b1abab; */
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
  /* border: 1px solid rgb(194, 192, 192); */
}

::v-deep .search-box-list-page .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
  /* border: 1px solid rgb(194, 192, 192); */
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
  min-width: 18.5px;
}

::v-deep .el-pagination button,
.el-pagination span:not {
  font-size: 0.75rem;
  height: 26px;
  line-height: 26px;
}

.table-land {
  position: relative;
}

.landQueryCondition {
  position: absolute;
  top: 90px;
  left: 0;
  width: calc(100% - 20px);
  padding: 10px 10px 0 10px;
  /* margin: 10px 10px; */
  border-bottom: 1px solid #e7e7e7;
  background: #fff;
  z-index: 99;
}

.landQueryCondition .queryButtonItem {
  display: flex;
  justify-content: flex-end;
}

.landQueryCondition .queryButtonItem .queryButton {
  width: 60px;
}

.shortcut-query {
  /* position: absolute;
  left: 421px;
  top: 25px; */
  margin-bottom: 10px;
}

::v-deep .el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 7px;
}

.need-area {
  width: 280px;
  display: flex;
  align-items: center;
}

.need-area-slider {
  display: inline-block;
  width: 100px;
  margin: 0 5px;
}

.need-area-input {
  width: 50px;
  display: inline-block;
  padding: 0 8px;
}

/* .need-area-input {
  width: 110px;
} */
.need-area-- {
  margin: 0 10px;
}

.table-box {
  width: 364px;
  position: absolute;
  right: 180px;
  top: 70px;
  background: #fff;
  box-shadow: 0px 3px 4px 0px #cdcdcd;
}

.table-box-title {
  text-align: left;
  background: #fff;
  color: #5c5c5c;
  height: 35px;
  line-height: 35px;
  font-size: 0.95rem;
  /*margin-bottom: 5px;*/
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-box-search1 {
  display: flex;
  height: 31px;
  background: #fff;
  /*margin-bottom: 10px;*/
  border: 1px solid #dfdfdf;
}

.land-search {
  width: 365px;
  padding: 15px 15px 10px 15px;
  background-color: #ffffff;
  /*margin-bottom: 2.5px;*/
  /*position: absolute;*/
  /*top: 20px;*/
  /*left: 10px;*/
  /*z-index: 1;*/
}

.new-query-content {
  background: #ffffff;
  margin-bottom: 5px;
  padding-top: 10px;
}

.land-use {
  /* margin-top: 1px; */
  margin-left: 10px;
}

.land-use-type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.land-use-item {
  font-size: 0.85rem;
  background: #f2f5ff;
  border-radius: 4px;
  padding: 4px 10px;
  cursor: pointer;
}

.table-box-search {
  display: flex;
  margin: 10px;
  height: 31px;
  border: 1px solid #eee;
}

.table-box-search-input {
  display: flex;
  margin: 4px 0;
  width: 396px;
  /* width: calc(100% - 60px); */
  border-right: 1px solid #e3e3e3;
}

::v-deep .table-box-search-input .el-input--mini .el-input__inner {
  height: 25px;
  line-height: 25px;
}

>>> .el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
  color: #409eff;
}

::v-deep .table-box-search-input .el-input__inner {
  border: none;
}

::v-deep input[type="text"]:focus {
  outline: none;
}

.table-box-search-btn1 {
  margin: 4px 0;
  padding: 0 5px;
  height: 23px;
  line-height: 23px;
  border-left: 1px solid #e3e3e3;
  cursor: pointer;
}

.table-box-search-btn {
  width: 40px;
  background: #2785de;
  color: #fff;
  margin: 4px 10px;
  text-align: center;
  border-radius: 15px;
  height: 23px;
  line-height: 23px;
  border-left: 1px solid #787676;
  cursor: pointer;
}

.table-park {
  /* min-height: 160px; */
  /* max-height: 500px; */
  height: 350px;
  overflow: auto;
}

/deep/ .layer-box {
  width: 78px;
  height: 26px;
  padding: 0 0 0 5px;
}

/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
  /*transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

/* 设置持续时间和动画函数 */
.slide-entry-enter-active {
  transition: all 0.3s ease;
}

.slide-entry-leave-active {
  transition: all 0.3s ease;
}

.slide-entry-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-10px);
  opacity: 0;
}

.available {
  /* position: absolute; */
  display: flex;
}

.icon-view {
  margin-left: 5px;
  font-size: 0.85rem;
  color: #ffffff;
}

.available-map {
  position: absolute;
  bottom: 10px;
  right: 800px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0 0 10px #d3d2d2;
  padding: 5px 15px 10px 15px;
}

.key-piece {
  display: inline-block;
  width: 13px;
  height: 8px;
}

.key-text {
  margin-left: 5px;
  color: #787676;
  font-size: 0.75rem;
}

.key-content {
  padding: 0 10px;
  margin-top: 5px;
  display: flex;
  align-items: center;
}

.key-content:nth-child(1) {
  margin-top: 0;
}

.item-content {
  display: flex;
  align-items: center;
  margin-top: 6px;
}

.item-content:nth-child(1) {
  /*margin-top: 0;*/
}

.key-img1 {
  width: 20px;
  height: 10px;
}

.key-img {
  width: 20px;
}

.key-img3 {
  width: 20px;
}

.imgStyle {
  width: 12px;
}

.unit {
  text-align: center;
}

.line {
  text-align: center;
}

.form-content {
  margin: 20px 10px 0 10px;
  padding-bottom: 10px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

.available-item {
  background: #ffffff;
  padding: 3px 10px;
  /* margin-top: 10px; */
  font-size: 0.85rem;
  /* font-weight: bold; */
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
  /* background: red; */
  width: 80px;
  height: 26px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.available-item:nth-child(1) {
  /* margin-top: 0; */
}

.statistics-content {
  /* position: absolute; */
  /* top: 60px; */
  /* left: 650px; */
  background: #ffffff;
  border-radius: 4px;
  padding: 20px;
  border: 2px solid #97c9be;
}

.statistics-assemble {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.statistics-card {
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.card-item {
  flex: 1;
  /*width: 70px;*/
  background: #f5e8ff;
  padding: 5px 10px;
  margin-left: 10px;
  text-align: right;
  cursor: pointer;
}

.card-item:nth-child(1) {
  margin-left: 0;
}

.card-name {
  font-size: 0.85rem;
  color: #868f89;
  /*white-space:nowrap;*/
}

.card-main {
  margin-top: 10px;
  background: url("~@/assets/newImg/img06.png") no-repeat;
}

.card-main2 {
  background: url("~@/assets/newImg/img07.png") no-repeat;
}

.card-main3 {
  background: url("~@/assets/newImg/img08.png") no-repeat;
}

.card-num {
  font-size: 1.37rem;
  font-weight: bold;
}

.card-unit {
  font-size: 0.75rem;
  margin-left: 5px;
}

.assemble-num1 {
  color: #4298fe;
}

.assemble-num2 {
  color: #05cd92;
}

.assemble-line {
  width: 1px;
  height: 40px;
  background: #e5e5e5;
}

.offerings-class1 {
  /* background: red; */
  color: #2c83f6 !important;
}

/* .offerings-color {
  color: #2c83f6 !important;
} */

.assemble-area {
  text-align: center;
}

.landUseIndex {
  background: #409eff;
  color: #ffffff !important;
}

.new-information {
  position: absolute;
  left: 50%;
  top: 200px;
}

.new-influence {
  position: absolute;
  left: 420px;
  bottom: 20px;
  z-index: 9999;
  width: calc(55% + 10px);
}

.statistics-content-expend {
  position: absolute;
  top: 70px;
  left: 411px;
  height: 30px;
  width: 20px;
  line-height: 30px;
  text-align: center;
  color: #3869d5;
  background: #fff;
  cursor: pointer;
}

.park-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  margin-right: 15px;
  color: #837e7e;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.tool-toolbar-box {
  position: relative;
  display: flex;
}
#tool-toolbar1 {
  position: absolute;
  top: 45px;
  left: -150px;
  background: #fff;
  padding: 10px;
  width: 350px;
}
.project-button {
  width: 100px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  margin-right: 15px;
  line-height: 32px;
  text-align: center;
  color: #837e7e;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.tool-search {
  /* width: 56%; */
  height: 32px;
  position: absolute;
  top: 20px;
  left: 10px;
  width: max-content;
  /* background: red; */
  display: flex;
  align-items: center;
  /* flex-wrap: wrap; */
}

.tool-box-search {
  display: flex;
  align-items: center;
}

.tool-box-search-input {
  width: 340px;
}

.tool-box-search-btn {
  width: 60px;
  height: 32px;
  background: #2c83f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 0px 4px 4px 0px;
  cursor: pointer;
}

.xzqh-tree {
  width: 180px;
  margin-left: 15px;

  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 0.85rem;
  color: #c0c4cc;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.xzqh-tree-title {
  width: 178px;
  color: #409eff;
  display: flex;
  justify-content: space-between;
  /* background: red; */
}

>>> .el-tree {
  max-height: 300px !important;
  overflow-y: auto;
  overflow-x: auto;
  color: #c0c4cc;
  border-radius: 4px;
}

.statistics-button {
  margin: 0px 5px 0 5px;
  width: 80px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #c0c4cc;
  text-align: center;
  cursor: pointer;
}

.offer-area {
  margin: 0px 5px 0 5px;
  width: 75px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #c0c4cc;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.offer-area-form {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  width: 340px;
  height: 50px;
  border-radius: 4px;
  /* position: absolute; */
  /* top: 50px; */
  /* left: 600px; */
  background: #fff;
  color: #c0c4cc;
}

.dklist {
  width: 396px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 54px;
  left: 10px;
  background: #fff;
  border-radius: 4px;
  color: #2c83f6;
  font-size: 0.85rem;
}

>>> .el-tree-node {
  max-height: 500px;
  overflow-y: auto;
}

>>> .el-tree-node::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #f5f5f5;
}

.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #000;
}

.shrink {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
  color: #2c83f6;
}

/* >>>.el-tree-node__content{
  background: #000;
}
>>>.el-tree-node.is-current{
  background: #fff;
} */
>>> .el-tree-node__content:hover {
  /* background-color: #337fcc; */
}

>>> .el-tree-node.is-current > .el-tree-node__content {
  background-color: #7cacdd !important;
  color: #fff;
}
.cb-btn {
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 12px;
  color: #c0c4cc;
  margin-left: 5px;
  cursor: pointer;
}
</style>
